import {LocalizationLanguages} from "./LocalizationsType";

export const DefaultLocalizations: LocalizationLanguages = {
   en: {
      addAnotherItemTitle: 'Item Added Successfully',
      addAnotherItemPrompt: 'Would you like to add another item?',
      addAnotherItem: 'Yes, Add another',
      addAnotherItemNo: 'No, Thanks',
      currency_dkk: 'DKK',
      currency_eur: "EUR",
      currency_gbp: "GBP",
      currency_nok: "NOK",
      currency_pln: "PLN",
      currency_sek: "SEK",
      currency_usd: "USD",
      currency_point: "POINT",
      loginPageTitle: 'Bring magic to your inbox',
      loginPageDescription: 'Submit your email and we will send you a link with access to our trade in universe of your previously purchased items.',
      loginPageDescription2: 'Let the trade in begin!',
      loginPageDescription3: '',
      loginPageBack: 'Back',
      publicPageTitle: 'Discover the value of your wardrobe',
      publicPageDescription: 'Here you can secure a new home for your used items. Send us your used items and get credit to spend in our webshop.',
      publicPageDescription2: 'We are buying items shopped here or other stores.',
      publicPagePageStartButton: 'Start tradeback',
      publicPageBackgroundImage: '',
      publicPageVideoUrl: '',
      mainPageEnterEmail: 'E-mail',
      mainPageMailSent: 'Thank you! We will send you an email with instructions.',
      mainPageMailSent2: '',
      mainPageSend: 'Submit',
      easyBoxTitle: 'As easy as 1,2,3!',
      easyBoxSection1Icon: '',
      easyBoxSection1Title: 'Trade it',
      easyBoxSection1Description: 'Select the items you want to trade in from a list of your previous purchases. We determine the credit - you spend it!',
      easyBoxSection2Icon: '',
      easyBoxSection2Title: 'Pack it',
      easyBoxSection2Description: 'Pack your clean items nicely and send it to us with a prepaid shipping label or code. That’s right! No shipping fees.',
      easyBoxSection3Icon: '',
      easyBoxSection3Title: 'Drop it off',
      easyBoxSection3Description: 'Drop off the package at your local drop off location and receive instant credit you can use on new or used items in our webshop!',
      easyBoxSection4Icon: '',
      easyBoxSection4Title: '',
      easyBoxSection4Description: '',
      easyBoxSignature: '',
      mainPageStepperReturns: 'Your returns',
      mainPageStepperProfile: 'Your informations',
      mainPageStepperPayout: 'Payout',
      mainPageStepperDelivery: 'Choose pickup',
      mainPageStepperComments: 'Comments',
      returnsDescriptionNone: 'You havent picked your returns yet. Add your first item to get started.',
      returnsAddItem: 'Add items',
      returnsAddItemMore: '',
      returnsAddItemButton: 'Add item',
      returnsTitleDirect: 'Items bought at {0}',
      returnsTitleSubText: '',
      returnsTitleRetail: 'Items bought at a retailer',
      returnsTitleDisallowed: 'Items unavailable for trade-in',
      countryWarningTitle: 'Trade-Ins might not be available in your area',
      countryWarningDescription: 'Thanks for stopping by, but it appears that you come from a country which is not yet fully supported',
      returnsValue: 'Value: ',
      returnsConfirmTrade: 'Trade in',
      wholeSaleAddTitle: 'Add item',
      wholeSaleAddDescription: 'Pick the category for your item, and upload a picture.',
      wholeSaleAddItem: 'Add item',
      wholeSaleAddItem2: 'Add item',
      wholeSaleSearchTitle: 'Search for style',
      wholeSaleSearchSubTitle: 'Locate the style by entering the style number found on the small carelabel inside your item and select from the list.',
      wholeSaleSearchGoCategory: 'Add item by category',
      wholeSaleSearchPlaceholder: 'Search for item',
      wholeSaleSearchNotFound: 'No matching styles found',
      wholeSaleSearchHowToTitle: 'How to find the style number',
      wholeSaleSearchHowToDescription: 'Look at the carelabel as shown on the picture',
      wholeSaleSearchHowToNotFoundTitle: 'Unable to locate the style number?',
      wholeSaleExcluded: 'Unable to trade-in',
      wholeSaleValuePrefix: '',
      wholeSaleAdditionalHeader: '',
      wholeSaleAdditionalDescription: '',
      wholeSaleSearchImageUrl: '',
      wholeSaleSearchItemSuffix: '',
      imageUploadText: 'Upload photo',
      categoryValue: 'Value: ',
      returnsCartHeaderReplacement: '',
      returnsCartHeader: 'For use at ',
      returnsCartNext: 'Continue',
      returnsConfirmDelete: 'Delete item?',
      returnsConfirmDeleteDescription: 'This action will delete the item from your list of returns.',
      returnsConfirmYes: '',
      returnsConfirmNo: '',
      returnsNothingTitle: 'You have no trade-in history',
      returnsNothingDesc: 'But keep looking, we will update this page when you trade with us.',
      profileTitle: 'Your profile',
      profileDescription: 'We need some information about you, so you can get your credit.',
      profileName: 'Full Name',
      profileRequired: 'This field is required',
      profileZipCode: 'Zipcode',
      profileZipCodeValidation: 'Zipcode is invalid',
      profileCity: 'City',
      profileAddress: 'Address',
      profileMail: 'Email',
      profileMailInvalid: 'Invalid email',
      profilePhone: 'Phone',
      profilePhonePrefix: 'Country Code',
      profilePhoneValidation: 'Phonenumber is invalid',
      profileDataMissingTitle: 'Please fill in all the missing fields',
      profileCountry: 'Country',
      profileLocale: 'Language',
      profileCountry_DK: 'Denmark',
      profileCountry_DE: 'Germany',
      profileCountry_AT: 'Austria',
      profileCountry_NL: 'Netherland',
      profileCountry_SE: 'Sweden',
      profileCountry_BE: 'Belgium',
      profileCountry_IE: 'Ireland',
      profileCountry_FR: 'France',
      profileCountry_ES: 'Spain',
      profileCountry_RO: 'Romania',
      profileCountry_SI: 'Slovenia',
      profileCountry_SK: 'Slovakia',
      profileCountry_CZ: 'Czech Republic',
      profileCountry_PL: 'Poland',
      profileCountry_BG: 'Bulgaria',
      profileCountry_CY: 'Cyprus',
      profileCountry_EE: 'Estonia',
      profileCountry_FI: 'Finland',
      profileCountry_GB: 'United Kingdom',
      profileCountry_GR: 'Greece',
      profileCountry_HR: 'Croatia',
      profileCountry_LT: 'Lithuania',
      profileCountry_LU: 'Luxembourg',
      profileCountry_LV: 'Latvia',
      profileCountry_HU: 'Hungary',
      profileCountry_MT: 'Malta',
      profileCountry_NO: 'Norway',
      profileCountry_PT: 'Portugal',
      profileCountry_IT: 'Italy',
      profileAcceptsTerms: 'Yes, i have read and accepts the',
      profileAcceptsTerms2: 'terms.',
      profileAcceptPart2: '',
      profileAcceptPart3: '',
      consumerConfirmTermsTitle: '',
      consumerConfirmTerms: 'We accept used clothing that functions perfectly and is in good condition. We will give you credit that can be used in our store. Please note that items will not be returned to customers. Items without garment tags or that are not in good working condition will be recycled and will not be returned.',
      consumerConfirmTerms1: 'Inspect your gear and make sure that what you\'re sending us is good quality.',
      consumerConfirmTerms2: 'Print the shipping label and ship us your gear.',
      consumerConfirmTerms3: '',
      consumerConfirmOk: 'OK',
      shippingTitle: 'Select drop off',
      shippingDescription: 'Select one of our the drop off possibilities. Below you find which ones are available in you neighborhood.',
      carrierName_shipmondo: 'Post Nord parcel shop',
      carrierDescription_shipmondo: 'Please print the shipping label and tape it on securely and visibly.',
      carrierName_pickup: 'Pick up',
      carrierDescription_pickup: 'You will be notified ASAP on how you decide when we can pick up the item(s) from your location',
      carrierName_dao: 'DAO',
      carrierDescription_dao: 'Send your package using the provided code',
      carrierName_gls: 'GLS',
      carrierDescription_gls: 'Please print the shipping label and tape it on securely and visibly.',
      carrierName_b2c: 'DHL',
      carrierDescription_b2c: 'Send your package using DHL',
      carrierName_dhl: 'DHL',
      carrierDescription_dhl: 'Send your package using DHL',
      consumerFreightNoService: 'We are sorry, but we currently have no drop off services in your area. If you think this is a mistake, please contact our customer service',
      tradeInTitle: 'Almost there!',
      tradeInDescription: 'Thank you for your trade in! The next steps are easy peasy - just follow the guide below.',
      tradeInMaximumTitle: 'Trade-in not allowed, maximum value exceeded',
      tradeInMaximumDesc: 'We are very sorry, but the value of your trade-in exceeds the maximum allowed value. Try removing an item from the trade-in and try again',
      tradeInMaximumCart: 'Unable to add more items',
      tradeInMaximumCart2: 'To continue the trade-in, please remove items so that the trade-in falls below',
      consumerAlmostTherePackIt: 'Pack it',
      consumerAlmostTherePackItDesc: 'Pack your clean items nicely. If possible, pay it back to Mother Earth using a non-virgin packaging. Secure the packaging and put the code or label visibly on it. The shipping is prepaid by us! If still in doubt see how below.',
      consumerAlmostTherePickupPackItDesc: 'Pack your clean items nicely. If possible, pay it back to Mother Earth using a non-virgin packaging. No shipping codes or labels needed - we will take care of that.',
      consumerAlmostTherePackItCode: 'Use personal packing code:',
      consumerAlmostTherePackItLabel: 'Print your packaging label:',
      consumerAlmostTherePackItQR: 'Show this QR code at a drop off point:',
      consumerAlmostTherePackItLabelButton: 'Click here',
      consumerAlmostTherePackItQRButton: 'Show QR fullscreen',
      consumerAlmostTherePackItHowTo: 'In doubt? click here',
      consumerAlmostThereDropOff: 'Drop off',
      consumerAlmostThereDropOffDesc: 'Drop off the package at a local drop off location. Find the one closest to you below.',
      consumerAlmostThereDropOffDescNoDrops: 'Drop off the package at a local drop off location.',
      consumerAlmostThereDropOffFindNearest: 'Find nearest drop off point',
      consumerAlmostThereCredit: 'Credit',
      consumerAlmostThereCreditDesc: 'Sit back and relax! We will send you an email once your credit is ready for use. You can also see the status of your trade ins under ‘Trade in history’. Thank you for being an environment conscious fashionista!',
      consumerAlmostTHereBackToStart: 'Back to start',
      consumerAlmostThereBackToStartUrl: '',
      consumerAlmostThereCTA1: '',
      consumerAlmostThereCTA1Url: '',
      consumerAlmostThereCTA2: '',
      consumerAlmostThereCTA2Url: '',
      consumerAlmostTherePickup2: 'Pick-up',
      consumerAlmostTherePickupDesc2: 'You will be notified ASAP to agree on a pick-up time',
      consumerAlmostTherePleaseWait: 'Please wait while we make transport arrangements for you ... ',
      consumerAlmostThereDelayedLine1: 'We are currently unable to generate a shipping label for you, but we will send it in an e-mail once it\'s ready.',
      consumerAlmostThereDelayedLine2: 'If you wish, you can keep this window open, and it will show a link to the shipping label as soon as it\'s ready.',
      consumerAlmostThereNoticeMail: 'Note. We have sent you an e-mail which includes the above information.',
      consumerAlmostThereStep1Image: '',
      consumerAlmostThereStep2Image: '',
      consumerAlmostThereStep3Image: '',
      consumerDropoffTitle: 'Dropoff points',
      consumerDropoffHide: 'Hide',
      consumerHowToApplyCode: 'How to use code',
      consumerHowToApplyLabel: 'How to apply label',
      consumerHowToApplyCodeSect1: 'Shipping code',
      consumerHowToApplyCodeSect1Desc: 'Before dropping the packaged off at the drop off location, write the 9 digit code visibly and with your best penmanship. Make sure to use a waterproof marker that doesn’t wipe off easily.',
      consumerHowToApplyCodeSect1Image: "",
      consumerHowToApplyCodeSect2: 'Shipping label',
      consumerHowToApplyCodeSect2Desc: 'Before dropping the packaged off at the drop off location, print the shipping label and tape it on securely and visibly. Make sure the tape doesn’t cover any of the print on the label.',
      consumerHowToApplyCodeSect2Image: "",
      consumerHowToApplyCodeQr: 'QR Code',
      consumerHowToApplyCodeQrDesc: 'Before handing the package over to your chosen package shop, you can show the digital shipping label QR at the drop off point. They will scan it and help you print the shipping label.',
      consumerHowToApplyCodeButton: 'Hide',
      consumerHowToApplyCodeQrImage: "",
      publicPageLoginTitle: 'Items bought online',
      publicPageLoginDescription: '',
      publicPageWholeSaleTitle: 'Items bought at a retailer',
      publicPageWholeSaleDescription: '',
      publicPageAlternativeTitle: '',
      publicPageAlternativeDescription: '',
      publicPageAlternativeField1: '',
      publicPageAlternativeField2: '',
      publicPageAlternativeField3: '',
      publicPageFooter: '',
      frontPageImage1: '',
      frontPageImage2: '',
      frontPageStep1Image: '',
      frontPageStep2Image: '',
      frontPageStep3Image: '',
      wholeSaleCreditButton: 'Receive {0} {1} credits',
      payoutTitle: 'Select your payout',
      payoutDescription: 'Select one of the following payout options.',
      payoutVoucher: 'Voucher for use online',
      payoutBank: 'Payout to partner',
      payoutConfirmOkay: 'Confirm',
      payoutConfirmCancel: 'Cancel',
      payoutFieldRequired: 'Field is required',
      payoutCreditCardTitle: 'Angiv konto og registreringsnummer',
      payoutCreditCardRegNr: 'Registration',
      payoutCreditCardAccount: 'Account number',
      payoutMobilePayTitle: 'Please provide mobilepay phonenumber',
      payoutMobilePayPhone: 'Phonenumber',
      historicPageLink: 'Your tradeins',
      historicPageTitle: 'Your historic tradeins',
      historicPageTradeInPrefix: "Created ",
      historicPageTradeInReceived: "Received",
      historicPageTradeInNotReceived: "Not received",
      historicPageTradeInVoucher: "Voucher: ",
      historicPageTradeInValue: "Current value: ",
      headlessCaption: "Please login to access trade-in",
      fetchingItems: "Please wait...",
      commentsPageTitle: "Tell us the story",
      commentsPageDescription: "We would love to hear your story about these items, how they were used and where",
      commentsPageAccept: "Yes, I accept that my first name and country of residence can be displayed in connection with the sale of this item.",
      commentsPagePlaceholder: "Your products story",
      itemInfoStore: "Store",
      itemInfoStoreTitle: "This item was bought in a store",
      itemInfoOnline: "Online",
      itemInfoOnlineTitle: "This item was bought online",
      dropoffQrInfo: "This dropoff point supports QR codes for easy package sending",
   },
   da: {
      addAnotherItemTitle: "Item tilføjet",
      addAnotherItemPrompt: "Vil du tilføje endnu et item til din pakke?",
      addAnotherItem: "Ja, tilføj et item",
      addAnotherItemNo: "Nej tak",
      currency_dkk: 'DKK',
      currency_eur: "EUR",
      currency_gbp: "GBP",
      currency_nok: "NOK",
      currency_pln: "PLN",
      currency_sek: "SEK",
      currency_usd: "USD",
      currency_point: "POINT",
      loginPageTitle: 'Få adgang til Trade-in universet nu!',
      loginPageDescription: 'Skriv din e-mailadresse og du vil modtage et link med adgang til vores trade-in univers med dine seneste køb.',
      loginPageDescription2: 'Er du klar? :-)',
      loginPageDescription3: '',
      loginPageBack: 'Tilbage',
      publicPageTitle: 'Opdag værdien af din garderobe',
      publicPageDescription: 'Her kan du sikre et nyt hjem til dine brugte varer. Det betyder ikke noget hvis du har købt varen her eller et andet sted. Send os dine brugte varer og få rabat i vores webshop.',
      publicPageDescription2: 'Vi køber items som du har købt online eller i andre butikker.',
      publicPagePageStartButton: 'Start indlevering',
      publicPageBackgroundImage: '',
      publicPageVideoUrl: '',
      mainPageEnterEmail: 'E-mail',
      mainPageMailSent: 'Tak! Vi sender dig en mail med yderligere instruktioner.',
      mainPageMailSent2: '',
      mainPageSend: 'Send',
      easyBoxTitle: 'Nemt og hurtigt!',
      easyBoxSection1Icon: '',
      easyBoxSection1Title: 'Trade in',
      easyBoxSection1Description: 'Vælg de varer fra dine tidligere indkøb, du gerne vil sende tilbage. Vi giver dig din kredit så snart pakken er afleveret, og så vælger du helt selv, hvad du vil bruge pengene på!',
      easyBoxSection2Icon: '',
      easyBoxSection2Title: 'Pak dine varer',
      easyBoxSection2Description: 'Pak dine rene varer ind og send dem tilbage til os med den fragtlabel eller kode, du får fra os. Ingen fragtomkostninger!',
      easyBoxSection3Icon: '',
      easyBoxSection3Title: 'Send retur',
      easyBoxSection3Description: 'Aflever din pakke hos din nærmeste pakkeshop og optjen din kredit som du enten kan bruge på nye eller andre secondhand varer på vores webshop!',
      easyBoxSection4Icon: '',
      easyBoxSection4Title: '',
      easyBoxSection4Description: '',
      easyBoxSignature: '',
      mainPageStepperReturns: 'Dine returneringer',
      mainPageStepperProfile: 'Dine oplysninger',
      mainPageStepperPayout: 'Udbetaling',
      mainPageStepperDelivery: 'Vælg aflevering',
      mainPageStepperComments: 'Kommentar',
      returnsDescriptionNone: 'Du har ikke valgt dine returneringer endnu. Tilføj dit første item for at komme i gang.',
      returnsAddItem: 'Tilføj items',
      returnsAddItemMore: '',
      returnsAddItemButton: 'Tilføj item',
      returnsTitleDirect: 'Items købt på {0}',
      returnsTitleSubText: '',
      returnsTitleRetail: 'Items købt hos forhandler',
      returnsTitleDisallowed: 'Nedenstående produkter kan vi desværre ikke modtage',
      returnsNothingTitle: 'Du har ingen nuværende trade-ins',
      returnsNothingDesc: 'Men hold øje, vi opdaterer denne side så snart du har :-)',
      countryWarningTitle: 'Indlevering er muligvis ikke tilgængelig i dit område',
      countryWarningDescription: 'Tak fordi du kiggede ind, men det ser ud til at du kommer fra et område, som vi endnu ikke understøtter fuldt ud. Hvis du mener det er en fejl - må du meget gerne tage fat i vores support. Tak for din forståelse!',
      returnsValue: 'Værdi: ',
      returnsConfirmTrade: 'Indlevér',
      wholeSaleAddTitle: 'Tilføj item',
      wholeSaleAddDescription: 'Vælg din kategori og upload dernæst dit billede af dit item.',
      wholeSaleAddItem: 'Tilføj item',
      wholeSaleAddItem2: 'Tilføj item',
      wholeSaleSearchTitle: 'Søg efter style',
      wholeSaleSearchSubTitle: 'Find din style ved at indtaste style nummeret som du finder på vaskeanvisningen og vælge fra listen.',
      wholeSaleSearchGoCategory: 'Tilføj via kategori',
      wholeSaleSearchPlaceholder: 'Søg efter item',
      wholeSaleSearchNotFound: 'Ingen styles matchede din søgning',
      wholeSaleSearchHowToTitle: 'Hvor finder jeg style nummeret?',
      wholeSaleSearchHowToDescription: 'Style nummeret finder du på vaskeanvisningen som vist på billedet',
      wholeSaleSearchHowToNotFoundTitle: 'Kan du ikke finde style nummeret?',
      wholeSaleExcluded: 'Kan ikke trades ind',
      wholeSaleValuePrefix: '',
      wholeSaleAdditionalHeader: '',
      wholeSaleAdditionalDescription: '',
      wholeSaleSearchImageUrl: '',
      wholeSaleSearchItemSuffix: '',
      imageUploadText: 'Upload photo',
      categoryValue: 'Værdi: ',
      returnsCartHeaderReplacement: '',
      returnsCartHeader: 'Til brug på ',
      returnsCartNext: 'Næste',
      returnsConfirmDelete: 'Slet item ?',
      returnsConfirmDeleteDescription: 'Sletter det valgte item fra dine returneringer, kan ikke fortrydes',
      returnsConfirmYes: '',
      returnsConfirmNo: '',
      profileTitle: 'Dine oplysninger',
      profileDescription: 'Vi har brug for nogle oplysninger, så du kan få din kredit.',
      profileName: 'Dit fulde navn',
      profileRequired: 'Dette felt er påkrævet',
      profileZipCode: 'Postnummer',
      profileZipCodeValidation: 'Postnummeret er ugyldigt, skal være mellem 1000 og 99999',
      profileCity: 'By',
      profileAddress: 'Adresse',
      profileMail: 'Email',
      profileMailInvalid: 'Ugyldig email',
      profilePhone: 'Telefon',
      profilePhonePrefix: 'Landekode',
      profileCountry: 'Land',
      profileLocale: 'Sprog',
      profileCountry_DK: 'Danmark',
      profileCountry_DE: 'Tyskland',
      profileCountry_AT: 'Østrig',
      profileCountry_NL: 'Holland',
      profileCountry_SE: 'Sverige',
      profileCountry_BE: 'Belgien',
      profileCountry_IE: 'Ireland',
      profileCountry_FR: 'Frankrig',
      profileCountry_ES: 'Spain',
      profileCountry_RO: 'Romania',
      profileCountry_SI: 'Slovenia',
      profileCountry_SK: 'Slovakia',
      profileCountry_CZ: 'Czech Republic',
      profileCountry_PL: 'Polen',
      profileCountry_BG: 'Bulgaria',
      profileCountry_CY: 'Cyprus',
      profileCountry_EE: 'Estonia',
      profileCountry_FI: 'Finland',
      profileCountry_GB: 'United Kingdom',
      profileCountry_GR: 'Greece',
      profileCountry_HR: 'Croatia',
      profileCountry_LT: 'Lithuania',
      profileCountry_LU: 'Luxembourg',
      profileCountry_LV: 'Latvia',
      profileCountry_HU: 'Hungary',
      profileCountry_MT: 'Malta',
      profileCountry_NO: 'Norway',
      profileCountry_PT: 'Portugal',
      profileCountry_IT: 'Italy',
      profilePhoneValidation: 'Telefonnummeret er ugyldigt',
      profileDataMissingTitle: 'Angiv alle de manglende oplysninger',
      profileAcceptsTerms: 'Ja, jeg har læst og accepterer',
      profileAcceptsTerms2: 'reglerne.',
      profileAcceptPart2: '',
      profileAcceptPart3: '',
      consumerConfirmTermsTitle: '',
      consumerConfirmTerms: 'Vi modtager super gerne dit tøj som er i god og ren stand. Vi giver dig credits som kan bruges på vores online butik. Venligst bemærk at indleveret tøj ikke returneres. Tøj uden vaske mærkninger, øvrige mærkninger og andet tøj, der ikke er i god nok stand til at blive videresolgt vil blive genbrugt og derfor heller ikke returneret.',
      consumerConfirmTerms1: 'For at være sikker på at næste ven af brandet kan få glæde af dit tøj, så send os tøj i god og ren stand med alle mærkninger inde i tøjet.',
      consumerConfirmTerms2: 'Når du har sikret dette, så print fragtlabel og send os dit tøj. Vi glæder os til at modtage det. ',
      consumerConfirmTerms3: '',
      consumerConfirmOk: 'OK',
      shippingTitle: 'Vælg hvordan du vil sende',
      shippingDescription: 'Vælg en af vores forsendelsesmuligheder. Nederst finder du oversigten over de muligheder, der er tilgængelige hvor du bor.',
      carrierName_shipmondo: 'Post Nord pakkeshop',
      carrierDescription_shipmondo: 'Venligst print din fragtlabel og tape den fast på pakken. Sørg for at den sidder så man tydeligt kan se den.',
      carrierName_pickup: 'Afhentning hjemme',
      carrierDescription_pickup: 'Du får snarest en besked om, hvordan og hvornår vi kan afhente varerne',
      carrierName_dao: 'DAO',
      carrierDescription_dao: 'Send din pakke med DAO, du modtager en kode som du skal skrive på pakken.',
      carrierName_gls: 'GLS',
      carrierDescription_gls: 'Venligst print din fragtlabel og tape den fast på pakken. Sørg for at den sidder så man tydeligt kan se den.',
      carrierName_b2c: 'DHL',
      carrierDescription_b2c: 'Send din pakke med DHL tyskland',
      carrierName_dhl: 'DHL',
      carrierDescription_dhl: 'Send din pakke med DHL tyskland',
      consumerFreightNoService: 'Vi beklager meget, vi har i øjeblikket ingen indleveringssteder i dit område. Hvis du mener det er en fejl, så tag fat i vores kundeservice.',
      tradeInTitle: 'Du er næsten i mål!',
      tradeInDescription: 'De sidste skridt er hurtige og nemme.',
      tradeInMaximumTitle: 'TradeIn kan ikke gennemføres, maksimum værdi overskredet',
      tradeInMaximumDesc: 'Desværre overstiger værdien af din tradein den maksimalt tilladte værdi. Prøv at fjerne et af dine styles før du fortsætter.',
      tradeInMaximumCart: 'Der kan ikke tilføjes flere items.',
      tradeInMaximumCart2: 'For at fortsætte trade-in, fjern venligst items så du kommer under maksimumbeløbet på ',
      consumerAlmostTherePackIt: 'Pak dine varer',
      consumerAlmostTherePackItDesc: 'Pak dine rene items så pænt som muligt. Hvis du har mulighed for at bruge genbrugt eller miljøvenlig indpakning, er det kun et plus! Sørg for at pakken er lukket ordentligt, og at label tydeligt kan ses. Vi betaler fragten!',
      consumerAlmostTherePickupPackItDesc: 'Pak dine rene items så pænt som muligt. Hvis du har mulighed for at bruge genbrugt eller miljøvenlig indpakning, er det kun et plus! Din kontaktperson kontakter dig på det aftalte tidspunkt.',
      consumerAlmostTherePackItCode: 'Brug denne personlige pakke-kode:',
      consumerAlmostTherePackItLabel: 'Udskriv denne fragtlabel:',
      consumerAlmostTherePackItQR: 'Vis denne QR kode i pakkeshoppen',
      consumerAlmostTherePackItLabelButton: 'Klik her',
      consumerAlmostTherePackItQRButton: 'Vis koden på fuld skærm',
      consumerAlmostTherePackItHowTo: 'I tvivl? Sådan gør du',
      consumerAlmostThereDropOff: 'Aflever hos en pakkeshop',
      consumerAlmostThereDropOffDesc: 'Aflever din pakke hos din nærmeste pakkeshop. Vælg din nærmeste pakkeshop her.',
      consumerAlmostThereDropOffDescNoDrops: 'Aflever din pakke hos din nærmeste pakkeshop.',
      consumerAlmostThereDropOffFindNearest: 'Find nærmeste pakkeshop',
      consumerAlmostThereCredit: 'Kredit',
      consumerAlmostThereCreditDesc: 'Så er du færdig og good to go! Vi sender dig en mail, så snart din kredit er klar på kontoen. Du er også altid velkommen til at tjekke din status i trade-ins under ’Trade in history’. Tak fordi du vil være med til at gøre mode mere bæredygtigt <3',
      consumerAlmostTHereBackToStart: 'Tilbage til forsiden',
      consumerAlmostThereBackToStartUrl: '',
      consumerAlmostThereCTA1: '',
      consumerAlmostThereCTA1Url: '',
      consumerAlmostThereCTA2: '',
      consumerAlmostThereCTA2Url: '',
      consumerAlmostTherePickup2: 'Afhentning hjemme',
      consumerAlmostTherePickupDesc2: 'Du får snarest muligt besked om at lave afhentningsaftale',
      consumerAlmostTherePleaseWait: 'Vent et øjeblik mens vi klargører ... ',
      consumerAlmostThereDelayedLine1: 'Vi er i øjeblikket ikke i stand til at generere en fragtlabel til dig. Vi sender den i en e-mail, når den er klar.',
      consumerAlmostThereDelayedLine2: 'Hvis du vil, kan du også holde dette vindue åbent, og du vil se et link direkte til din fragtlabel, så snart, den er klar.',
      consumerAlmostThereNoticeMail: 'Bemærk. Vi har sendt dig en e-mail som inkluderer ovenstående informationer.',
      consumerAlmostThereStep1Image: '',
      consumerAlmostThereStep2Image: '',
      consumerAlmostThereStep3Image: '',
      consumerHowToApplyCode: 'Sådan bruger du din pakkekode',
      consumerHowToApplyLabel: 'Sådan tilføjer du din fragtlabel',
      consumerHowToApplyCodeSect1: 'Fragtkode',
      consumerHowToApplyCodeSect1Desc: 'Før du afleverer pakken hos din valgte pakkeshop, skal du skrive den 9-cifrede kode tydeligt og med din pænest mulige håndskrift :-) Sørg for at du bruger en vandfast kuglepen, der ikke nemt smitter af.',
      consumerHowToApplyCodeSect1Image: "",
      consumerHowToApplyCodeSect2: 'Fragtlabel',
      consumerHowToApplyCodeSect2Desc: 'Før du afleverer pakken hos din valgte pakkeshop, skal du printe fragtlabel og tape det fast på pakken. Sørg for at det sidder, så man tydeligt kan se det, og at tapen ikke dækker printet eller stregkoden på din label.',
      consumerHowToApplyCodeSect2Image: "",
      consumerHowToApplyCodeQr: 'QR-kode',
      consumerHowToApplyCodeQrDesc: 'Før du afleverer pakken til din valgte pakkeshop, kan du vise QR-koden på indleveringsstedet. De scanner den og hjælper dig med at printe fragtlabelen.',
      consumerHowToApplyCodeQrImage: "",
      consumerHowToApplyCodeButton: 'Skjul',
      consumerDropoffTitle: 'Find nærmeste pakkeshop',
      consumerDropoffHide: 'Skjul',
      publicPageLoginTitle: 'Varer købt online',
      publicPageLoginDescription: '',
      publicPageWholeSaleTitle: 'Varer købt hos en forhandler',
      publicPageWholeSaleDescription: '',
      publicPageAlternativeTitle: '',
      publicPageAlternativeDescription: '',
      publicPageAlternativeField1: '',
      publicPageAlternativeField2: '',
      publicPageAlternativeField3: '',
      publicPageFooter: '',
      frontPageImage1: '',
      frontPageImage2: '',
      frontPageStep1Image: '',
      frontPageStep2Image: '',
      frontPageStep3Image: '',
      wholeSaleCreditButton: 'Modtag {0} {1} i kredit',
      payoutTitle: 'Vælg din udbetaling',
      payoutDescription: 'Vælg den af følgende udbetalingsmuligheder som du ønsker at benytte',
      payoutVoucher: 'Rabatkode til shop',
      payoutBank: 'Udbetaling til bank konto',
      payoutConfirmOkay: 'Bekræft',
      payoutConfirmCancel: 'Fortryd',
      payoutFieldRequired: 'Felt er påkrævet',
      payoutCreditCardTitle: 'Angiv konto og registreringsnummer',
      payoutCreditCardRegNr: 'Reg. nr',
      payoutCreditCardAccount: 'Kontonummer',
      payoutMobilePayTitle: 'Angiv mobilepay telefonnummer',
      payoutMobilePayPhone: 'Telefon',
      historicPageLink: 'Dine tradeins',
      historicPageTitle: 'Dine tidligere tradeins',
      historicPageTradeInPrefix: "Oprettet d.",
      historicPageTradeInReceived: "Modtaget",
      historicPageTradeInNotReceived: "Ikke modtaget",
      historicPageTradeInVoucher: "Voucher: ",
      historicPageTradeInValue: "Aktuel værdi: ",
      headlessCaption: "Please login to access trade-in",
      fetchingItems: "Henter data, vent et øjeblik...",
      commentsPageTitle: "Fortæl os din historie",
      commentsPageDescription: "Vi vil meget gerne høre historien om disse items",
      commentsPageAccept: "Ja, jeg accepterer at mit fornavn og hjemland kan vises i forbindelse med salget af dette item",
      commentsPagePlaceholder: "Dit products historie",
      itemInfoStore: "Butik",
      itemInfoStoreTitle: "Dette item er købt i en butik",
      itemInfoOnline: "Online",
      itemInfoOnlineTitle: "Dette item er købt online",
      dropoffQrInfo: "Dette afleveringssted understøtter QR-koder til nem pakkeforsendelse",
   },
   de: {
      addAnotherItemTitle: "Artikel erfolgreich hinzugefügt",
      addAnotherItemPrompt: "Möchten Sie einen weiteren Artikel hinzufügen?",
      addAnotherItem: "Ja, einen weiteren hinzufügen",
      addAnotherItemNo: "Nein, danke",
      currency_dkk: 'DKK',
      currency_eur: "EUR",
      currency_gbp: "GBP",
      currency_nok: "NOK",
      currency_pln: "PLN",
      currency_sek: "SEK",
      currency_usd: "USD",
      currency_point: "PUNKT",
      loginPageTitle: 'Bringe Magie in deinen Posteingang',
      loginPageDescription: 'Gib deine E-Mail ein und wir senden dir einen Link für den Zugang zu unserem Trade-in-Universum deiner zuvor gekauften Artikel.',
      loginPageDescription2: 'Lass den Rücktausch beginnen!',
      loginPageDescription3: '',
      loginPageBack: 'Zurück',
      publicPageTitle: 'Entdecke den Wert deiner Garderobe',
      publicPageDescription: 'Hier kannst du für deine gebrauchten Artikel ein neues Zuhause sichern. Sende uns deine gebrauchten Artikel und erhalte Guthaben für unseren Webshop.',
      publicPageDescription2: 'Wir kaufen Artikel, die hier oder in anderen Geschäften gekauft wurden.',
      publicPagePageStartButton: 'Rücktausch starten',
      publicPageBackgroundImage: '',
      publicPageVideoUrl: '',
      mainPageEnterEmail: 'E-Mail',
      mainPageMailSent: 'Vielen Dank! Wir senden dir eine E-Mail mit Anweisungen.',
      mainPageMailSent2: '',
      mainPageSend: 'Absenden',
      easyBoxTitle: 'So einfach wie 1,2,3!',
      easyBoxSection1Icon: '',
      easyBoxSection1Title: 'Tausche es',
      easyBoxSection1Description: 'Wähle die Artikel, die du zurücktauschen möchtest, aus einer Liste deiner früheren Einkäufe. Wir bestimmen das Guthaben - du gibst es aus!',
      easyBoxSection2Icon: '',
      easyBoxSection2Title: 'Verpacke es',
      easyBoxSection2Description: 'Verpacke deine sauberen Artikel ordentlich und sende sie mit einem vorfrankierten Versandetikett oder Code an uns. Richtig! Keine Versandkosten.',
      easyBoxSection3Icon: '',
      easyBoxSection3Title: 'Gib es ab',
      easyBoxSection3Description: 'Gib das Paket an deiner lokalen Abgabestelle ab und erhalte sofortiges Guthaben, das du für neue oder gebrauchte Artikel in unserem Webshop verwenden kannst!',
      easyBoxSection4Icon: '',
      easyBoxSection4Title: '',
      easyBoxSection4Description: '',
      easyBoxSignature: '',
      mainPageStepperReturns: 'Deine Rücksendungen',
      mainPageStepperProfile: 'Deine Informationen',
      mainPageStepperPayout: 'Auszahlung',
      mainPageStepperDelivery: 'Abholung wählen',
      mainPageStepperComments: 'Kommentare',
      returnsDescriptionNone: 'Du hast noch keine Rücksendungen ausgewählt. Füge deinen ersten Artikel hinzu, um zu beginnen.',
      returnsAddItem: 'Artikel hinzufügen',
      returnsAddItemMore: '',
      returnsAddItemButton: 'Artikel hinzufügen',
      countryWarningTitle: 'Rücktausch ist in deiner Region möglicherweise nicht verfügbar',
      countryWarningDescription: 'Danke für deinen Besuch, aber es scheint, dass du aus einem Land kommst, das noch nicht vollständig unterstützt wird',
      returnsValue: 'Wert: ',
      returnsConfirmTrade: 'Eintauschen',
      wholeSaleAddTitle: 'Artikel hinzufügen',
      wholeSaleAddDescription: 'Wähle die Kategorie für deinen Artikel und lade ein Bild hoch.',
      wholeSaleAddItem: 'Artikel hinzufügen',
      wholeSaleAddItem2: 'Artikel hinzufügen',
      wholeSaleSearchTitle: 'Nach Stil suchen',
      wholeSaleSearchSubTitle: 'Finde den Stil, indem du die Stilnummer eingibst, die du auf dem kleinen Pflegeetikett in deinem Artikel findest, und wähle aus der Liste aus.',
      wholeSaleSearchGoCategory: 'Artikel nach Kategorie hinzufügen',
      wholeSaleSearchPlaceholder: 'Nach Artikel suchen',
      wholeSaleSearchNotFound: 'Keine passenden Stile gefunden',
      wholeSaleSearchHowToTitle: 'Wie man die Stilnummer findet',
      wholeSaleSearchHowToDescription: 'Schau auf das Pflegeetikett, wie auf dem Bild gezeigt',
      wholeSaleSearchHowToNotFoundTitle: 'Stilnummer nicht zu finden?',
      wholeSaleExcluded: 'Rücktausch nicht möglich',
      wholeSaleValuePrefix: '',
      wholeSaleAdditionalHeader: '',
      wholeSaleAdditionalDescription: '',
      wholeSaleSearchImageUrl: '',
      wholeSaleSearchItemSuffix: '',
      imageUploadText: 'Foto hochladen',
      categoryValue: 'Wert: ',
      returnsCartHeaderReplacement: '',
      returnsCartHeader: 'Zur Verwendung bei ',
      returnsCartNext: 'Weiter',
      returnsConfirmDelete: 'Artikel löschen?',
      returnsConfirmDeleteDescription: 'Diese Aktion wird den Artikel aus deiner Rücksendeliste löschen.',
      returnsConfirmYes: '',
      returnsConfirmNo: '',
      returnsTitleDirect: 'Bei {0} gekaufte Artikel',
      returnsTitleSubText: '',
      returnsTitleRetail: 'Im Einzelhandel gekaufte Artikel',
      returnsTitleDisallowed: 'Artikel, die nicht für den Rücktausch verfügbar sind',
      returnsNothingTitle: 'Du hast keine Rücktausch-Historie',
      returnsNothingDesc: 'Aber schau weiter, wir aktualisieren diese Seite, wenn du mit uns handelst.',
      profileTitle: 'Dein Profil',
      profileDescription: 'Wir benötigen einige Informationen über dich, damit du dein Guthaben erhalten kannst.',
      profileName: 'Vollständiger Name',
      profileRequired: 'Dieses Feld ist erforderlich',
      profileZipCode: 'Postleitzahl',
      profileZipCodeValidation: 'Postleitzahl ist ungültig',
      profileCity: 'Stadt',
      profileAddress: 'Adresse',
      profileMail: 'E-Mail',
      profileMailInvalid: 'Die E-Mail sieht falsch aus, bitte korrigiere sie',
      profilePhone: 'Telefon',
      profilePhonePrefix: 'Ländervorwahl',
      profilePhoneValidation: 'Telefonnummer ist ungültig',
      profileDataMissingTitle: 'Bitte fülle alle fehlenden Felder aus',
      profileCountry: 'Land',
      profileLocale: 'Sprache',
      profileCountry_DK: 'Dänemark',
      profileCountry_DE: 'Deutschland',
      profileCountry_AT: 'Österreich',
      profileCountry_NL: 'Niederlande',
      profileCountry_SE: 'Schweden',
      profileCountry_BE: 'Belgien',
      profileCountry_IE: 'Irland',
      profileCountry_FR: 'Frankreich',
      profileCountry_ES: 'Spanien',
      profileCountry_RO: 'Rumänien',
      profileCountry_SI: 'Slowenien',
      profileCountry_SK: 'Slowakei',
      profileCountry_CZ: 'Tschechische Republik',
      profileCountry_PL: 'Polen',
      profileCountry_BG: 'Bulgarien',
      profileCountry_CY: 'Zypern',
      profileCountry_EE: 'Estland',
      profileCountry_FI: 'Finnland',
      profileCountry_GB: 'Vereinigtes Königreich',
      profileCountry_GR: 'Griechenland',
      profileCountry_HR: 'Kroatien',
      profileCountry_LT: 'Litauen',
      profileCountry_LU: 'Luxemburg',
      profileCountry_LV: 'Lettland',
      profileCountry_HU: 'Ungarn',
      profileCountry_MT: 'Malta',
      profileCountry_NO: 'Norwegen',
      profileCountry_PT: 'Portugal',
      profileCountry_IT: 'Italien',
      profileAcceptsTerms: 'Ja, ich habe die',
      profileAcceptsTerms2: 'Bedingungen gelesen und akzeptiert.',
      profileAcceptPart2: '',
      profileAcceptPart3: '',
      consumerConfirmTermsTitle: '',
      consumerConfirmTerms: 'Wir akzeptieren gebrauchte Kleidung, die einwandfrei funktioniert und in gutem Zustand ist. Wir geben dir Guthaben, das in unserem Geschäft verwendet werden kann. Bitte beachte, dass Artikel nicht an Kunden zurückgegeben werden. Artikel ohne Kleidungsetiketten oder die nicht in gutem Zustand sind, werden recycelt und nicht zurückgegeben.',
      consumerConfirmTerms1: 'Überprüfe deine Ausrüstung und stelle sicher, dass das, was du uns schickst, von guter Qualität ist.',
      consumerConfirmTerms2: 'Drucke das Versandetikett aus und sende uns deine Ausrüstung.',
      consumerConfirmTerms3: '',
      consumerConfirmOk: 'OK',
      shippingTitle: 'Abgabestelle wählen',
      shippingDescription: 'Wähle eine unserer Abgabemöglichkeiten. Unten findest du, welche in deiner Nachbarschaft verfügbar sind.',
      carrierName_shipmondo: 'Post Nord Paketshop',
      carrierDescription_shipmondo: 'Bitte drucke das Versandetikett aus und klebe es sicher und sichtbar auf.',
      carrierName_pickup: 'Abholung',
      carrierDescription_pickup: 'Du wirst so schnell wie möglich darüber informiert, wie du entscheiden kannst, wann wir den/die Artikel von deinem Standort abholen können',
      carrierName_dao: 'DAO',
      carrierDescription_dao: 'Sende dein Paket mit dem bereitgestellten Code',
      carrierName_gls: 'GLS',
      carrierDescription_gls: 'Bitte drucke das Versandetikett aus und klebe es sicher und sichtbar auf.',
      carrierName_b2c: 'DHL',
      carrierDescription_b2c: 'Sende dein Paket mit DHL',
      carrierName_dhl: 'DHL',
      carrierDescription_dhl: 'Sende dein Paket mit DHL',
      consumerFreightNoService: 'Es tut uns leid, aber derzeit haben wir keine Abgabedienste in deiner Gegend. Wenn du denkst, dass dies ein Fehler ist, kontaktiere bitte unseren Kundenservice',
      tradeInTitle: 'Fast geschafft!',
      tradeInDescription: 'Vielen Dank für deinen Rücktausch! Die nächsten Schritte sind kinderleicht - folge einfach der Anleitung unten.',
      tradeInMaximumTitle: 'Rücktausch nicht erlaubt, maximaler Wert überschritten',
      tradeInMaximumDesc: 'Es tut uns sehr leid, aber der Wert deines Rücktauschs überschreitet den maximal zulässigen Wert. Versuche, einen Artikel aus dem Rücktausch zu entfernen und versuche es erneut',
      tradeInMaximumCart: 'Keine weiteren Artikel können hinzugefügt werden',
      tradeInMaximumCart2: 'Um mit dem Rücktausch fortzufahren, entferne bitte Artikel, sodass der Rücktausch unter',
      consumerAlmostTherePackIt: 'Verpacke es',
      consumerAlmostTherePackItDesc: 'Verpacke deine sauberen Artikel ordentlich. Wenn möglich, zahle es an Mutter Erde zurück, indem du eine nicht-jungfräuliche Verpackung verwendest. Sichere die Verpackung und bringe den Code oder das Etikett sichtbar an. Der Versand wird von uns bezahlt! Bei Zweifeln sieh unten nach, wie es geht.',
      consumerAlmostTherePickupPackItDesc: 'Verpacke deine sauberen Artikel ordentlich. Wenn möglich, zahle es an Mutter Erde zurück, indem du eine nicht-jungfräuliche Verpackung verwendest. Keine Versandcodes oder Etiketten nötig - wir kümmern uns darum.',
      consumerAlmostTherePackItCode: 'Verwende persönlichen Verpackungscode:',
      consumerAlmostTherePackItLabel: 'Drucke dein Verpackungsetikett:',
      consumerAlmostTherePackItQR: 'Zeige diesen QR-Code bei einer Abgabestelle:',
      consumerAlmostTherePackItLabelButton: 'Hier klicken',
      consumerAlmostTherePackItQRButton: 'QR-Code im Vollbildmodus anzeigen',
      consumerAlmostTherePackItHowTo: 'Im Zweifel? Klicke hier',
      consumerAlmostThereDropOff: 'Abgabe',
      consumerAlmostThereDropOffDesc: 'Gib das Paket an einer lokalen Abgabestelle ab. Finde unten die nächstgelegene.',
      consumerAlmostThereDropOffDescNoDrops: 'Gib das Paket an einer lokalen Abgabestelle ab.',
      consumerAlmostThereDropOffFindNearest: 'Nächste Abgabestelle finden',
      consumerAlmostThereCredit: 'Guthaben',
      consumerAlmostThereCreditDesc: 'Lehn dich zurück und entspanne! Wir senden dir eine E-Mail, sobald dein Guthaben zur Verwendung bereit ist. Du kannst den Status deiner Rücktausche auch unter "Rücktausch-Historie" sehen. Vielen Dank, dass du ein umweltbewusster Modekenner bist!',
      consumerAlmostTHereBackToStart: 'Zurück zum Start',
      consumerAlmostThereBackToStartUrl: '',
      consumerAlmostThereCTA1: '',
      consumerAlmostThereCTA1Url: '',
      consumerAlmostThereCTA2: '',
      consumerAlmostThereCTA2Url: '',
      consumerAlmostTherePickup2: 'Abholung',
      consumerAlmostTherePickupDesc2: 'Du wirst so schnell wie möglich benachrichtigt, um einen Abholtermin zu vereinbaren',
      consumerAlmostTherePleaseWait: 'Bitte warte, während wir Transportvereinbarungen für dich treffen ... ',
      consumerAlmostThereDelayedLine1: 'Wir können dir derzeit keine Versanddetails zur Verfügung stellen, aber wir senden dir eine E-Mail, wenn diese bereit sind',
      consumerAlmostThereDelayedLine2: 'Wenn du möchtest, kannst du dieses Fenster geöffnet lassen, es wird die Versanddetails anzeigen, sobald sie bereit sind',
      consumerAlmostThereNoticeMail: 'Hinweis. Wir haben dir eine E-Mail mit den oben genannten Informationen gesendet.',
      consumerAlmostThereStep1Image: '',
      consumerAlmostThereStep2Image: '',
      consumerAlmostThereStep3Image: '',
      consumerDropoffTitle: 'Abgabestellen',
      consumerDropoffHide: 'Ausblenden',
      consumerHowToApplyCode: 'Wie man den Code verwendet',
      consumerHowToApplyLabel: 'Wie man das Etikett anbringt',
      consumerHowToApplyCodeSect1: 'Versandcode',
      consumerHowToApplyCodeSect1Desc: 'Bevor du das Paket an der Abgabestelle abgibst, schreibe den 9-stelligen Code sichtbar und mit deiner besten Handschrift auf. Stelle sicher, dass du einen wasserfesten Marker verwendest, der nicht leicht abwischt.',
      consumerHowToApplyCodeSect1Image: "",
      consumerHowToApplyCodeSect2: 'Versandetikett',
      consumerHowToApplyCodeSect2Desc: 'Bevor du das Paket an der Abgabestelle abgibst, drucke das Versandetikett aus und klebe es sicher und sichtbar auf. Stelle sicher, dass das Klebeband keinen Teil des Drucks auf dem Etikett verdeckt.',
      consumerHowToApplyCodeSect2Image: "",
      consumerHowToApplyCodeQr: 'QR-Code',
      consumerHowToApplyCodeQrDesc: 'Bevor du das Paket in deinem gewählten Paketshop abgibst, kannst du das digitale Versandetikett-QR an der Abgabestelle vorzeigen. Sie werden es scannen und dir beim Ausdrucken des Versandetiketts helfen.',
      consumerHowToApplyCodeQrImage: "",
      consumerHowToApplyCodeButton: 'Ausblenden',
      publicPageLoginTitle: 'Online gekaufte Artikel',
      publicPageLoginDescription: '',
      publicPageWholeSaleTitle: 'Im Einzelhandel gekaufte Artikel',
      publicPageWholeSaleDescription: '',
      publicPageAlternativeTitle: '',
      publicPageAlternativeDescription: '',
      publicPageAlternativeField1: '',
      publicPageAlternativeField2: '',
      publicPageAlternativeField3: '',
      publicPageFooter: '',
      frontPageImage1: '',
      frontPageImage2: '',
      frontPageStep1Image: '',
      frontPageStep2Image: '',
      frontPageStep3Image: '',
      wholeSaleCreditButton: 'Erhalte {0} {1} Guthaben',
      payoutTitle: 'Wähle deine Auszahlung',
      payoutDescription: 'Wähle eine der folgenden Auszahlungsoptionen',
      payoutVoucher: 'Gutschein für den Shop',
      payoutBank: 'Barauszahlung auf Bankkonto',
      payoutConfirmOkay: 'Bestätigen',
      payoutConfirmCancel: 'Abbrechen',
      payoutFieldRequired: 'Feld ist erforderlich',
      payoutCreditCardTitle: 'Gib Konto- und Registrierungsnummer an',
      payoutCreditCardRegNr: 'Registrierung',
      payoutCreditCardAccount: 'Kontonummer',
      payoutMobilePayTitle: 'MobilePay-Telefonnummer angeben',
      payoutMobilePayPhone: 'Telefonnummer',
      historicPageLink: 'Deine Rücktausche',
      historicPageTitle: 'Deine Rücktausche',
      historicPageTradeInPrefix: "Erstellt am ",
      historicPageTradeInReceived: "Erhalten",
      historicPageTradeInNotReceived: "Nicht erhalten",
      historicPageTradeInVoucher: "Gutschein: ",
      historicPageTradeInValue: "Aktueller Wert: ",
      headlessCaption: "Bitte melde dich an, um auf den Rücktausch zuzugreifen",
      fetchingItems: "Bitte warten...",
      commentsPageTitle: "Erzähle uns die Geschichte",
      commentsPageDescription: "Wir würden gerne deine Geschichte über diese Artikel hören, wie sie verwendet wurden und wo",
      commentsPageAccept: "Ja, ich akzeptiere, dass mein Vorname und mein Wohnsitzland im Zusammenhang mit dem Verkauf dieses Artikels angezeigt werden können.",
      commentsPagePlaceholder: "Deine Produktgeschichte",
      itemInfoStore: "Geschäft",
      itemInfoStoreTitle: "Dieser Artikel wurde in einem Geschäft gekauft",
      itemInfoOnline: "Online",
      itemInfoOnlineTitle: "Dieser Artikel wurde online gekauft",
      dropoffQrInfo: "Diese Abgabestelle unterstützt QR-Codes für einfaches Versenden von Paketen"
   },
   sv: {
      addAnotherItemTitle: 'Item Added Successfully',
      addAnotherItemPrompt: 'Would you like to add another item?',
      addAnotherItem: 'Yes, Add another',
      addAnotherItemNo: 'No, Thanks',
      currency_dkk: 'DKK',
      currency_eur: "EUR",
      currency_gbp: "GBP",
      currency_nok: "NOK",
      currency_pln: "PLN",
      currency_sek: "SEK",
      currency_usd: "USD",
      currency_point: "POINT",
      loginPageTitle: 'Bring magic to your inbox',
      loginPageDescription: 'Submit your email and we will send you a link with access to our trade in universe of your previously purchased items.',
      loginPageDescription2: 'Let the trade in begin!',
      loginPageDescription3: '',
      loginPageBack: 'Back',
      publicPageTitle: 'Discover the value of your wardrobe',
      publicPageDescription: 'Here you can secure a new home for your used items. Send us your used items and get credit to spend in our webshop.',
      publicPageDescription2: 'We are buying items shopped here or other stores.',
      publicPagePageStartButton: 'Start tradeback',
      publicPageBackgroundImage: '',
      publicPageVideoUrl: '',
      mainPageEnterEmail: 'E-mail',
      mainPageMailSent: 'Thank you! We will send you an email with instructions.',
      mainPageMailSent2: '',
      mainPageSend: 'Submit',
      easyBoxTitle: 'As easy as 1,2,3!',
      easyBoxSection1Icon: '',
      easyBoxSection1Title: 'Trade it',
      easyBoxSection1Description: 'Select the items you want to trade in from a list of your previous purchases. We determine the credit - you spend it!',
      easyBoxSection2Icon: '',
      easyBoxSection2Title: 'Pack it',
      easyBoxSection2Description: 'Pack your clean items nicely and send it to us with a prepaid shipping label or code. That’s right! No shipping fees.',
      easyBoxSection3Icon: '',
      easyBoxSection3Title: 'Drop it off',
      easyBoxSection3Description: 'Drop off the package at your local drop off location and receive instant credit you can use on new or used items in our webshop!',
      easyBoxSection4Icon: '',
      easyBoxSection4Title: '',
      easyBoxSection4Description: '',
      easyBoxSignature: '',
      mainPageStepperReturns: 'Your returns',
      mainPageStepperProfile: 'Your informations',
      mainPageStepperPayout: 'Payout',
      mainPageStepperDelivery: 'Choose pickup',
      mainPageStepperComments: 'Comments',
      returnsDescriptionNone: 'You havent picked your returns yet. Add your first item to get started.',
      returnsAddItem: 'Add items',
      returnsAddItemMore: '',
      returnsAddItemButton: 'Add item',
      returnsTitleDirect: 'Items bought at {0}',
      returnsTitleSubText: '',
      returnsTitleRetail: 'Items bought at a retailer',
      returnsTitleDisallowed: 'Items unavailable for trade-in',
      countryWarningTitle: 'Trade-Ins might not be available in your area',
      countryWarningDescription: 'Thanks for stopping by, but it appears that you come from a country which is not yet fully supported',
      returnsValue: 'Value: ',
      returnsConfirmTrade: 'Trade in',
      wholeSaleAddTitle: 'Add item',
      wholeSaleAddDescription: 'Pick the category for your item, and upload a picture.',
      wholeSaleAddItem: 'Add item',
      wholeSaleAddItem2: 'Add item',
      wholeSaleSearchTitle: 'Search for style',
      wholeSaleSearchSubTitle: 'Locate the style by entering the style number found on the small carelabel inside your item and select from the list.',
      wholeSaleSearchGoCategory: 'Add item by category',
      wholeSaleSearchPlaceholder: 'Search for item',
      wholeSaleSearchNotFound: 'No matching styles found',
      wholeSaleSearchHowToTitle: 'How to find the style number',
      wholeSaleSearchHowToDescription: 'Look at the carelabel as shown on the picture',
      wholeSaleSearchHowToNotFoundTitle: 'Unable to locate the style number?',
      wholeSaleExcluded: 'Unable to trade-in',
      wholeSaleValuePrefix: '',
      wholeSaleAdditionalHeader: '',
      wholeSaleAdditionalDescription: '',
      wholeSaleSearchImageUrl: '',
      wholeSaleSearchItemSuffix: '',
      imageUploadText: 'Upload photo',
      categoryValue: 'Value: ',
      returnsCartHeaderReplacement: '',
      returnsCartHeader: 'For use at ',
      returnsCartNext: 'Continue',
      returnsConfirmDelete: 'Delete item?',
      returnsConfirmDeleteDescription: 'This action will delete the item from your list of returns.',
      returnsConfirmYes: '',
      returnsConfirmNo: '',
      returnsNothingTitle: 'You have no trade-in history',
      returnsNothingDesc: 'But keep looking, we will update this page when you trade with us.',
      profileTitle: 'Your profile',
      profileDescription: 'We need some information about you, so you can get your credit.',
      profileName: 'Full Name',
      profileRequired: 'This field is required',
      profileZipCode: 'Zipcode',
      profileZipCodeValidation: 'Zipcode is invalid',
      profileCity: 'City',
      profileAddress: 'Adress',
      profileMail: 'Email',
      profileMailInvalid: 'Invalid email',
      profilePhone: 'Phone',
      profilePhonePrefix: 'Country Code',
      profilePhoneValidation: 'Phonenumber is invalid',
      profileDataMissingTitle: 'Please fill in all the missing fields',
      profileCountry: 'Country',
      profileLocale: 'Language',
      profileCountry_DK: 'Denmark',
      profileCountry_DE: 'Germany',
      profileCountry_AT: 'Austria',
      profileCountry_NL: 'Netherland',
      profileCountry_SE: 'Sweden',
      profileCountry_BE: 'Belgium',
      profileCountry_IE: 'Ireland',
      profileCountry_FR: 'France',
      profileCountry_ES: 'Spain',
      profileCountry_RO: 'Romania',
      profileCountry_SI: 'Slovenia',
      profileCountry_SK: 'Slovakia',
      profileCountry_CZ: 'Czech Republic',
      profileCountry_PL: 'Poland',
      profileCountry_BG: 'Bulgaria',
      profileCountry_CY: 'Cyprus',
      profileCountry_EE: 'Estonia',
      profileCountry_FI: 'Finland',
      profileCountry_GB: 'United Kingdom',
      profileCountry_GR: 'Greece',
      profileCountry_HR: 'Croatia',
      profileCountry_LT: 'Lithuania',
      profileCountry_LU: 'Luxembourg',
      profileCountry_LV: 'Latvia',
      profileCountry_HU: 'Hungary',
      profileCountry_MT: 'Malta',
      profileCountry_NO: 'Norway',
      profileCountry_PT: 'Portugal',
      profileCountry_IT: 'Italy',
      profileAcceptsTerms: 'Yes, i have read and accepts the',
      profileAcceptsTerms2: 'terms.',
      profileAcceptPart2: '',
      profileAcceptPart3: '',
      consumerConfirmTermsTitle: '',
      consumerConfirmTerms: 'We accept used clothing that functions perfectly and is in good condition. We will give you credit that can be used in our store. Please note that items will not be returned to customers. Items without garment tags or that are not in good working condition will be recycled and will not be returned.',
      consumerConfirmTerms1: 'Inspect your gear and make sure that what you\'re sending us is good quality.',
      consumerConfirmTerms2: 'Print the shipping label and ship us your gear.',
      consumerConfirmTerms3: '',
      consumerConfirmOk: 'OK',
      shippingTitle: 'Select drop off',
      shippingDescription: 'Select one of our the drop off possibilities. Below you find which ones are available in you neighborhood.',
      carrierName_shipmondo: 'Post Nord parcel shop',
      carrierDescription_shipmondo: 'Please print the shipping label and tape it on securely and visibly.',
      carrierName_pickup: 'Pick up',
      carrierDescription_pickup: 'You will be notified ASAP on how you decide when we can pick up the item(s) from your location',
      carrierName_dao: 'DAO',
      carrierDescription_dao: 'Send your package using the provided code',
      carrierName_gls: 'GLS',
      carrierDescription_gls: 'Please print the shipping label and tape it on securely and visibly.',
      carrierName_b2c: 'DHL',
      carrierDescription_b2c: 'Send your package using DHL',
      carrierName_dhl: 'DHL',
      carrierDescription_dhl: 'Send your package using DHL',
      consumerFreightNoService: 'We are sorry, but we currently have no drop off services in your area. If you think this is a mistake, please contact our customer service',
      tradeInTitle: 'Almost there!',
      tradeInDescription: 'Thank you for your trade in! The next steps are easy peasy - just follow the guide below.',
      tradeInMaximumTitle: 'TradeIn not allowed, maximum value exceeded',
      tradeInMaximumDesc: 'We are very sorry, but the value of your tradein exceeds the maximum allowed value. Try removing an item from the tradein and try again',
      tradeInMaximumCart: 'Unable to add more items',
      tradeInMaximumCart2: 'To continue the trade-in, please remove items so that the trade-in falls below',
      consumerAlmostTherePackIt: 'Pack it',
      consumerAlmostTherePackItDesc: 'Pack your clean items nicely. If possible, pay it back to Mother Earth using a non-virgin packaging. Secure the packaging and put the code or label visibly on it. The shipping is prepaid by us! If still in doubt see how below.',
      consumerAlmostTherePickupPackItDesc: 'Pack your clean items nicely. If possible, pay it back to Mother Earth using a non-virgin packaging. No shipping codes or labels needed - we will take care of that.',
      consumerAlmostTherePackItCode: 'Use personal packing code:',
      consumerAlmostTherePackItLabel: 'Print your packaging label:',
      consumerAlmostTherePackItQR: 'Show this QR code at a drop off point:',
      consumerAlmostTherePackItLabelButton: 'Click here',
      consumerAlmostTherePackItQRButton: 'Show QR fullscreen',
      consumerAlmostTherePackItHowTo: 'In doubt? click here',
      consumerAlmostThereDropOff: 'Drop off',
      consumerAlmostThereDropOffDesc: 'Drop off the package at a local drop off location. Find the one closest to you below.',
      consumerAlmostThereDropOffDescNoDrops: 'Drop off the package at a local drop off location.',
      consumerAlmostThereDropOffFindNearest: 'Find nearest drop off point',
      consumerAlmostThereCredit: 'Credit',
      consumerAlmostThereCreditDesc: 'Sit back and relax! We will send you an email once your credit is ready for use. You can also see the status of your trade ins under ‘Trade in history’. Thank you for being an environment conscious fashionista!',
      consumerAlmostTHereBackToStart: 'Back to start',
      consumerAlmostThereBackToStartUrl: '',
      consumerAlmostThereCTA1: '',
      consumerAlmostThereCTA1Url: '',
      consumerAlmostThereCTA2: '',
      consumerAlmostThereCTA2Url: '',
      consumerAlmostTherePickup2: 'Pick-up',
      consumerAlmostTherePickupDesc2: 'You will be notified ASAP to agree on a pick-up time',
      consumerAlmostTherePleaseWait: 'Please wait while we make transport arrangements for you ... ',
      consumerAlmostThereDelayedLine1: 'We are currently unable to provide you with shipping details, but we will send you an e-mail when its ready',
      consumerAlmostThereDelayedLine2: 'If you wish, you can keep this window open, it will show the shipping details when they are ready',
      consumerAlmostThereNoticeMail: 'Notera. Vi har skickat ett e-postmeddelande till dig som innehåller ovanstående information.',
      consumerAlmostThereStep1Image: '',
      consumerAlmostThereStep2Image: '',
      consumerAlmostThereStep3Image: '',
      consumerDropoffTitle: 'Dropoff points',
      consumerDropoffHide: 'Hide',
      consumerHowToApplyCode: 'How to use code',
      consumerHowToApplyLabel: 'How to apply label',
      consumerHowToApplyCodeSect1: 'Shipping code',
      consumerHowToApplyCodeSect1Desc: 'Before dropping the packaged off at the drop off location, write the 9 digit code visibly and with your best penmanship. Make sure to use a waterproof marker that doesn’t wipe off easily.',
      consumerHowToApplyCodeSect1Image: "",
      consumerHowToApplyCodeSect2: 'Shipping label',
      consumerHowToApplyCodeSect2Desc: 'Before dropping the packaged off at the drop off location, print the shipping label and tape it on securely and visibly. Make sure the tape doesn’t cover any of the print on the label.',
      consumerHowToApplyCodeSect2Image: "",
      consumerHowToApplyCodeQr: 'QR Code',
      consumerHowToApplyCodeQrDesc: 'Before handing the package over to your chosen package shop, you can show the digital shipping label QR at the drop off point. They will scan it and help you print the shipping label.',
      consumerHowToApplyCodeQrImage: "",
      consumerHowToApplyCodeButton: 'Hide',
      publicPageLoginTitle: 'Items bought online',
      publicPageLoginDescription: '',
      publicPageWholeSaleTitle: 'Items bought at a retailer',
      publicPageWholeSaleDescription: '',
      publicPageAlternativeTitle: '',
      publicPageAlternativeDescription: '',
      publicPageAlternativeField1: '',
      publicPageAlternativeField2: '',
      publicPageAlternativeField3: '',
      publicPageFooter: '',
      frontPageImage1: '',
      frontPageImage2: '',
      frontPageStep1Image: '',
      frontPageStep2Image: '',
      frontPageStep3Image: '',
      wholeSaleCreditButton: 'Receive {0} {1} credits',
      payoutTitle: 'Select your payout',
      payoutDescription: 'Select one of the following payout options.',
      payoutVoucher: 'Voucher for shop',
      payoutBank: 'Payout to partner',
      payoutConfirmOkay: 'Confirm',
      payoutConfirmCancel: 'Cancel',
      payoutFieldRequired: 'Field is required',
      payoutCreditCardTitle: 'Angiv konto og registreringsnummer',
      payoutCreditCardRegNr: 'Registration',
      payoutCreditCardAccount: 'Account number',
      payoutMobilePayTitle: 'Please provide mobilepay phonenumber',
      payoutMobilePayPhone: 'Phonenumber',
      historicPageLink: 'Your tradeins',
      historicPageTitle: 'Your historic tradeins',
      historicPageTradeInPrefix: "Created ",
      historicPageTradeInReceived: "Received",
      historicPageTradeInNotReceived: "Not received",
      historicPageTradeInVoucher: "Voucher: ",
      historicPageTradeInValue: "Current value: ",
      headlessCaption: "Please login to access trade-in",
      fetchingItems: "Please wait...",
      commentsPageTitle: "Tell us the story",
      commentsPageDescription: "We would love to hear your story about these items, how they were used and where",
      commentsPageAccept: "Yes, I accept that my first name and country of residence can be displayed in connection with the sale of this item.",
      commentsPagePlaceholder: "Your products story",
      itemInfoStore: "Store",
      itemInfoStoreTitle: "This item was bought in a store",
      itemInfoOnline: "Online",
      itemInfoOnlineTitle: "This item was bought online",
      dropoffQrInfo: "Denna avlämningspunkt stöder QR-koder för enkel paketförsändelse",
   },
   fr: {
      addAnotherItemTitle: 'Item Added Successfully',
      addAnotherItemPrompt: 'Would you like to add another item?',
      addAnotherItem: 'Yes, Add another',
      addAnotherItemNo: 'No, Thanks',
      currency_dkk: 'DKK',
      currency_eur: "EUR",
      currency_gbp: "GBP",
      currency_nok: "NOK",
      currency_pln: "PLN",
      currency_sek: "SEK",
      currency_usd: "USD",
      currency_point: "POINT",
      loginPageTitle: 'Bring magic to your inbox',
      loginPageDescription: 'Submit your email and we will send you a link with access to our trade in universe of your previously purchased items.',
      loginPageDescription2: 'Let the trade in begin!',
      loginPageDescription3: '',
      loginPageBack: 'Back',
      publicPageTitle: 'Discover the value of your wardrobe',
      publicPageDescription: 'Here you can secure a new home for your used items. Send us your used items and get credit to spend in our webshop.',
      publicPageDescription2: 'We are buying items shopped here or other stores.',
      publicPagePageStartButton: 'Start tradeback',
      publicPageBackgroundImage: '',
      publicPageVideoUrl: '',
      mainPageEnterEmail: 'E-mail',
      mainPageMailSent: 'Thank you! We will send you an email with instructions.',
      mainPageMailSent2: '',
      mainPageSend: 'Submit',
      easyBoxTitle: 'As easy as 1,2,3!',
      easyBoxSection1Icon: '',
      easyBoxSection1Title: 'Trade it',
      easyBoxSection1Description: 'Select the items you want to trade in from a list of your previous purchases. We determine the credit - you spend it!',
      easyBoxSection2Icon: '',
      easyBoxSection2Title: 'Pack it',
      easyBoxSection2Description: 'Pack your clean items nicely and send it to us with a prepaid shipping label or code. That’s right! No shipping fees.',
      easyBoxSection3Icon: '',
      easyBoxSection3Title: 'Drop it off',
      easyBoxSection3Description: 'Drop off the package at your local drop off location and receive instant credit you can use on new or used items in our webshop!',
      easyBoxSection4Icon: '',
      easyBoxSection4Title: '',
      easyBoxSection4Description: '',
      easyBoxSignature: '',
      mainPageStepperReturns: 'Your returns',
      mainPageStepperProfile: 'Your informations',
      mainPageStepperPayout: 'Payout',
      mainPageStepperDelivery: 'Choose pickup',
      mainPageStepperComments: 'Comments',
      returnsDescriptionNone: 'You havent picked your returns yet. Add your first item to get started.',
      returnsAddItem: 'Add items',
      returnsAddItemMore: '',
      returnsAddItemButton: 'Add item',
      returnsTitleDirect: 'Items bought at {0}',
      returnsTitleSubText: '',
      returnsTitleRetail: 'Items bought at a retailer',
      returnsTitleDisallowed: 'Items unavailable for trade-in',
      countryWarningTitle: 'Trade-Ins might not be available in your area',
      countryWarningDescription: 'Thanks for stopping by, but it appears that you come from a country which is not yet fully supported',
      returnsValue: 'Value: ',
      returnsConfirmTrade: 'Trade in',
      wholeSaleAddTitle: 'Add item',
      wholeSaleAddDescription: 'Pick the category for your item, and upload a picture.',
      wholeSaleAddItem: 'Add item',
      wholeSaleAddItem2: 'Add item',
      wholeSaleSearchTitle: 'Search for style',
      wholeSaleSearchSubTitle: 'Locate the style by entering the style number found on the small carelabel inside your item and select from the list.',
      wholeSaleSearchGoCategory: 'Add item by category',
      wholeSaleSearchPlaceholder: 'Search for item',
      wholeSaleSearchNotFound: 'No matching styles found',
      wholeSaleSearchHowToTitle: 'How to find the style number',
      wholeSaleSearchHowToDescription: 'Look at the carelabel as shown on the picture',
      wholeSaleSearchHowToNotFoundTitle: 'Unable to locate the style number?',
      wholeSaleExcluded: 'Unable to trade-in',
      wholeSaleValuePrefix: '',
      wholeSaleAdditionalHeader: '',
      wholeSaleAdditionalDescription: '',
      wholeSaleSearchImageUrl: '',
      wholeSaleSearchItemSuffix: '',
      imageUploadText: 'Upload photo',
      categoryValue: 'Value: ',
      returnsCartHeaderReplacement: '',
      returnsCartHeader: 'For use at ',
      returnsCartNext: 'Continue',
      returnsConfirmDelete: 'Delete item?',
      returnsConfirmDeleteDescription: 'This action will delete the item from your list of returns.',
      returnsConfirmYes: '',
      returnsConfirmNo: '',
      returnsNothingTitle: 'You have no trade-in history',
      returnsNothingDesc: 'But keep looking, we will update this page when you trade with us.',
      profileTitle: 'Your profile',
      profileDescription: 'We need some information about you, so you can get your credit.',
      profileName: 'Full Name',
      profileRequired: 'This field is required',
      profileZipCode: 'Zipcode',
      profileZipCodeValidation: 'Zipcode is invalid',
      profileCity: 'City',
      profileAddress: 'Adresse',
      profileMail: 'Email',
      profileMailInvalid: 'Invalid email',
      profilePhone: 'Phone',
      profilePhonePrefix: 'Country Code',
      profilePhoneValidation: 'Phonenumber is invalid',
      profileDataMissingTitle: 'Please fill in all the missing fields',
      profileCountry: 'Country',
      profileLocale: 'Language',
      profileCountry_DK: 'Denmark',
      profileCountry_DE: 'Germany',
      profileCountry_AT: 'Austria',
      profileCountry_NL: 'Netherland',
      profileCountry_SE: 'Sweden',
      profileCountry_BE: 'Belgium',
      profileCountry_IE: 'Ireland',
      profileCountry_FR: 'France',
      profileCountry_ES: 'Spain',
      profileCountry_RO: 'Romania',
      profileCountry_SI: 'Slovenia',
      profileCountry_SK: 'Slovakia',
      profileCountry_CZ: 'Czech Republic',
      profileCountry_PL: 'Poland',
      profileCountry_BG: 'Bulgaria',
      profileCountry_CY: 'Cyprus',
      profileCountry_EE: 'Estonia',
      profileCountry_FI: 'Finland',
      profileCountry_GB: 'United Kingdom',
      profileCountry_GR: 'Greece',
      profileCountry_HR: 'Croatia',
      profileCountry_LT: 'Lithuania',
      profileCountry_LU: 'Luxembourg',
      profileCountry_LV: 'Latvia',
      profileCountry_HU: 'Hungary',
      profileCountry_MT: 'Malta',
      profileCountry_NO: 'Norway',
      profileCountry_PT: 'Portugal',
      profileCountry_IT: 'Italy',
      profileAcceptsTerms: 'Yes, i have read and accepts the',
      profileAcceptsTerms2: 'terms.',
      profileAcceptPart2: '',
      profileAcceptPart3: '',
      consumerConfirmTermsTitle: '',
      consumerConfirmTerms: 'We accept used clothing that functions perfectly and is in good condition. We will give you credit that can be used in our store. Please note that items will not be returned to customers. Items without garment tags or that are not in good working condition will be recycled and will not be returned.',
      consumerConfirmTerms1: 'Inspect your gear and make sure that what you\'re sending us is good quality.',
      consumerConfirmTerms2: 'Print the shipping label and ship us your gear.',
      consumerConfirmTerms3: '',
      consumerConfirmOk: 'OK',
      shippingTitle: 'Select drop off',
      shippingDescription: 'Select one of our the drop off possibilities. Below you find which ones are available in you neighborhood.',
      carrierName_shipmondo: 'Post Nord parcel shop',
      carrierDescription_shipmondo: 'Please print the shipping label and tape it on securely and visibly.',
      carrierName_pickup: 'Pick up',
      carrierDescription_pickup: 'You will be notified ASAP on how you decide when we can pick up the item(s) from your location',
      carrierName_dao: 'DAO',
      carrierDescription_dao: 'Send your package using the provided code',
      carrierName_gls: 'GLS',
      carrierDescription_gls: 'Please print the shipping label and tape it on securely and visibly.',
      carrierName_b2c: 'DHL',
      carrierDescription_b2c: 'Send your package using DHL',
      carrierName_dhl: 'DHL',
      carrierDescription_dhl: 'Send your package using DHL',
      consumerFreightNoService: 'We are sorry, but we currently have no drop off services in your area. If you think this is a mistake, please contact our customer service',
      tradeInTitle: 'Almost there!',
      tradeInDescription: 'Thank you for your trade in! The next steps are easy peasy - just follow the guide below.',
      tradeInMaximumTitle: 'TradeIn not allowed, maximum value exceeded',
      tradeInMaximumDesc: 'We are very sorry, but the value of your tradein exceeds the maximum allowed value. Try removing an item from the tradein and try again',
      tradeInMaximumCart: 'Unable to add more items',
      tradeInMaximumCart2: 'To continue the trade-in, please remove items so that the trade-in falls below',
      consumerAlmostTherePackIt: 'Pack it',
      consumerAlmostTherePackItDesc: 'Pack your clean items nicely. If possible, pay it back to Mother Earth using a non-virgin packaging. Secure the packaging and put the code or label visibly on it. The shipping is prepaid by us! If still in doubt see how below.',
      consumerAlmostTherePickupPackItDesc: 'Pack your clean items nicely. If possible, pay it back to Mother Earth using a non-virgin packaging. No shipping codes or labels needed - we will take care of that.',
      consumerAlmostTherePackItCode: 'Use personal packing code:',
      consumerAlmostTherePackItLabel: 'Print your packaging label:',
      consumerAlmostTherePackItQR: 'Show this QR code at a drop off point:',
      consumerAlmostTherePackItLabelButton: 'Click here',
      consumerAlmostTherePackItQRButton: 'Show QR fullscreen',
      consumerAlmostTherePackItHowTo: 'In doubt? click here',
      consumerAlmostThereDropOff: 'Drop off',
      consumerAlmostThereDropOffDesc: 'Drop off the package at a local drop off location. Find the one closest to you below.',
      consumerAlmostThereDropOffDescNoDrops: 'Drop off the package at a local drop off location.',
      consumerAlmostThereDropOffFindNearest: 'Find nearest drop off point',
      consumerAlmostThereCredit: 'Credit',
      consumerAlmostThereCreditDesc: 'Sit back and relax! We will send you an email once your credit is ready for use. You can also see the status of your trade ins under ‘Trade in history’. Thank you for being an environment conscious fashionista!',
      consumerAlmostTHereBackToStart: 'Back to start',
      consumerAlmostThereBackToStartUrl: '',
      consumerAlmostThereCTA1: '',
      consumerAlmostThereCTA1Url: '',
      consumerAlmostThereCTA2: '',
      consumerAlmostThereCTA2Url: '',
      consumerAlmostTherePickup2: 'Pick-up',
      consumerAlmostTherePickupDesc2: 'You will be notified ASAP to agree on a pick-up time',
      consumerAlmostTherePleaseWait: 'Please wait while we make transport arrangements for you ... ',
      consumerAlmostThereDelayedLine1: 'We are currently unable to provide you with shipping details, but we will send you an e-mail when its ready',
      consumerAlmostThereDelayedLine2: 'If you wish, you can keep this window open, it will show the shipping details when they are ready',
      consumerAlmostThereNoticeMail: 'Note. Nous vous avons envoyé un e-mail contenant les informations ci-dessus.',
      consumerAlmostThereStep1Image: '',
      consumerAlmostThereStep2Image: '',
      consumerAlmostThereStep3Image: '',
      consumerDropoffTitle: 'Dropoff points',
      consumerDropoffHide: 'Hide',
      consumerHowToApplyCode: 'How to use code',
      consumerHowToApplyLabel: 'How to apply label',
      consumerHowToApplyCodeSect1: 'Shipping code',
      consumerHowToApplyCodeSect1Desc: 'Before dropping the packaged off at the drop off location, write the 9 digit code visibly and with your best penmanship. Make sure to use a waterproof marker that doesn’t wipe off easily.',
      consumerHowToApplyCodeSect1Image: "",
      consumerHowToApplyCodeSect2: 'Shipping label',
      consumerHowToApplyCodeSect2Desc: 'Before dropping the packaged off at the drop off location, print the shipping label and tape it on securely and visibly. Make sure the tape doesn’t cover any of the print on the label.',
      consumerHowToApplyCodeSect2Image: "",
      consumerHowToApplyCodeQr: 'QR Code',
      consumerHowToApplyCodeQrDesc: 'Before handing the package over to your chosen package shop, you can show the digital shipping label QR at the drop off point. They will scan it and help you print the shipping label.',
      consumerHowToApplyCodeQrImage: "",
      consumerHowToApplyCodeButton: 'Hide',
      publicPageLoginTitle: 'Items bought online',
      publicPageLoginDescription: '',
      publicPageWholeSaleTitle: 'Items bought at a retailer',
      publicPageWholeSaleDescription: '',
      publicPageAlternativeTitle: '',
      publicPageAlternativeDescription: '',
      publicPageAlternativeField1: '',
      publicPageAlternativeField2: '',
      publicPageAlternativeField3: '',
      publicPageFooter: '',
      frontPageImage1: '',
      frontPageImage2: '',
      frontPageStep1Image: '',
      frontPageStep2Image: '',
      frontPageStep3Image: '',
      wholeSaleCreditButton: 'Receive {0} {1} credits',
      payoutTitle: 'Select your payout',
      payoutDescription: 'Select one of the following payout options.',
      payoutVoucher: 'Voucher for shop',
      payoutBank: 'Payout to partner',
      payoutConfirmOkay: 'Confirm',
      payoutConfirmCancel: 'Cancel',
      payoutFieldRequired: 'Field is required',
      payoutCreditCardTitle: 'Angiv konto og registreringsnummer',
      payoutCreditCardRegNr: 'Registration',
      payoutCreditCardAccount: 'Account number',
      payoutMobilePayTitle: 'Please provide mobilepay phonenumber',
      payoutMobilePayPhone: 'Phonenumber',
      historicPageLink: 'Your tradeins',
      historicPageTitle: 'Your historic tradeins',
      historicPageTradeInPrefix: "Created ",
      historicPageTradeInReceived: "Received",
      historicPageTradeInNotReceived: "Not received",
      historicPageTradeInVoucher: "Voucher: ",
      historicPageTradeInValue: "Current value: ",
      headlessCaption: "Please login to access trade-in",
      fetchingItems: "Please wait...",
      commentsPageTitle: "Tell us the story",
      commentsPageDescription: "We would love to hear your story about these items, how they were used and where",
      commentsPageAccept: "Yes, I accept that my first name and country of residence can be displayed in connection with the sale of this item.",
      commentsPagePlaceholder: "Your products story",
      itemInfoStore: "Store",
      itemInfoStoreTitle: "This item was bought in a store",
      itemInfoOnline: "Online",
      itemInfoOnlineTitle: "This item was bought online",
      dropoffQrInfo: "Ce point de dépôt prend en charge les codes QR pour un envoi de colis facile",
   },
   es: {
      addAnotherItemTitle: 'Item Added Successfully',
      addAnotherItemPrompt: 'Would you like to add another item?',
      addAnotherItem: 'Yes, Add another',
      addAnotherItemNo: 'No, Thanks',
      currency_dkk: 'DKK',
      currency_eur: "EUR",
      currency_gbp: "GBP",
      currency_nok: "NOK",
      currency_pln: "PLN",
      currency_sek: "SEK",
      currency_usd: "USD",
      currency_point: "POINT",
      loginPageTitle: 'Bring magic to your inbox',
      loginPageDescription: 'Submit your email and we will send you a link with access to our trade in universe of your previously purchased items.',
      loginPageDescription2: 'Let the trade in begin!',
      loginPageDescription3: '',
      loginPageBack: 'Back',
      publicPageTitle: 'Discover the value of your wardrobe',
      publicPageDescription: 'Here you can secure a new home for your used items. Send us your used items and get credit to spend in our webshop.',
      publicPageDescription2: 'We are buying items shopped here or other stores.',
      publicPagePageStartButton: 'Start tradeback',
      publicPageBackgroundImage: '',
      publicPageVideoUrl: '',
      mainPageEnterEmail: 'E-mail',
      mainPageMailSent: 'Thank you! We will send you an email with instructions.',
      mainPageMailSent2: '',
      mainPageSend: 'Submit',
      easyBoxTitle: 'As easy as 1,2,3!',
      easyBoxSection1Icon: '',
      easyBoxSection1Title: 'Trade it',
      easyBoxSection1Description: 'Select the items you want to trade in from a list of your previous purchases. We determine the credit - you spend it!',
      easyBoxSection2Icon: '',
      easyBoxSection2Title: 'Pack it',
      easyBoxSection2Description: 'Pack your clean items nicely and send it to us with a prepaid shipping label or code. That’s right! No shipping fees.',
      easyBoxSection3Icon: '',
      easyBoxSection3Title: 'Drop it off',
      easyBoxSection3Description: 'Drop off the package at your local drop off location and receive instant credit you can use on new or used items in our webshop!',
      easyBoxSection4Icon: '',
      easyBoxSection4Title: '',
      easyBoxSection4Description: '',
      easyBoxSignature: '',
      mainPageStepperReturns: 'Your returns',
      mainPageStepperProfile: 'Your informations',
      mainPageStepperPayout: 'Payout',
      mainPageStepperDelivery: 'Choose pickup',
      mainPageStepperComments: 'Comments',
      returnsDescriptionNone: 'You havent picked your returns yet. Add your first item to get started.',
      returnsAddItem: 'Add items',
      returnsAddItemMore: '',
      returnsAddItemButton: 'Add item',
      returnsTitleDirect: 'Items bought at {0}',
      returnsTitleSubText: '',
      returnsTitleRetail: 'Items bought at a retailer',
      returnsTitleDisallowed: 'Items unavailable for trade-in',
      countryWarningTitle: 'Trade-Ins might not be available in your area',
      countryWarningDescription: 'Thanks for stopping by, but it appears that you come from a country which is not yet fully supported',
      returnsValue: 'Value: ',
      returnsConfirmTrade: 'Trade in',
      wholeSaleAddTitle: 'Add item',
      wholeSaleAddDescription: 'Pick the category for your item, and upload a picture.',
      wholeSaleAddItem: 'Add item',
      wholeSaleAddItem2: 'Add item',
      wholeSaleSearchTitle: 'Search for style',
      wholeSaleSearchSubTitle: 'Locate the style by entering the style number found on the small carelabel inside your item and select from the list.',
      wholeSaleSearchGoCategory: 'Add item by category',
      wholeSaleSearchPlaceholder: 'Search for item',
      wholeSaleSearchNotFound: 'No matching styles found',
      wholeSaleSearchHowToTitle: 'How to find the style number',
      wholeSaleSearchHowToDescription: 'Look at the carelabel as shown on the picture',
      wholeSaleSearchHowToNotFoundTitle: 'Unable to locate the style number?',
      wholeSaleExcluded: 'Unable to trade-in',
      wholeSaleValuePrefix: '',
      wholeSaleAdditionalHeader: '',
      wholeSaleAdditionalDescription: '',
      wholeSaleSearchImageUrl: '',
      wholeSaleSearchItemSuffix: '',
      imageUploadText: 'Upload photo',
      categoryValue: 'Value: ',
      returnsCartHeaderReplacement: '',
      returnsCartHeader: 'For use at ',
      returnsCartNext: 'Continue',
      returnsConfirmDelete: 'Delete item?',
      returnsConfirmDeleteDescription: 'This action will delete the item from your list of returns.',
      returnsConfirmYes: '',
      returnsConfirmNo: '',
      returnsNothingTitle: 'You have no trade-in history',
      returnsNothingDesc: 'But keep looking, we will update this page when you trade with us.',
      profileTitle: 'Your profile',
      profileDescription: 'We need some information about you, so you can get your credit.',
      profileName: 'Full Name',
      profileRequired: 'This field is required',
      profileZipCode: 'Zipcode',
      profileZipCodeValidation: 'Zipcode is invalid',
      profileCity: 'City',
      profileAddress: 'Dirección',
      profileMail: 'Email',
      profileMailInvalid: 'Invalid email',
      profilePhone: 'Phone',
      profilePhonePrefix: 'Country Code',
      profilePhoneValidation: 'Phonenumber is invalid',
      profileDataMissingTitle: 'Please fill in all the missing fields',
      profileCountry: 'Country',
      profileLocale: 'Language',
      profileCountry_DK: 'Denmark',
      profileCountry_DE: 'Germany',
      profileCountry_AT: 'Austria',
      profileCountry_NL: 'Netherland',
      profileCountry_SE: 'Sweden',
      profileCountry_BE: 'Belgium',
      profileCountry_IE: 'Ireland',
      profileCountry_FR: 'France',
      profileCountry_ES: 'Spain',
      profileCountry_RO: 'Romania',
      profileCountry_SI: 'Slovenia',
      profileCountry_SK: 'Slovakia',
      profileCountry_CZ: 'Czech Republic',
      profileCountry_PL: 'Poland',
      profileCountry_BG: 'Bulgaria',
      profileCountry_CY: 'Cyprus',
      profileCountry_EE: 'Estonia',
      profileCountry_FI: 'Finland',
      profileCountry_GB: 'United Kingdom',
      profileCountry_GR: 'Greece',
      profileCountry_HR: 'Croatia',
      profileCountry_LT: 'Lithuania',
      profileCountry_LU: 'Luxembourg',
      profileCountry_LV: 'Latvia',
      profileCountry_HU: 'Hungary',
      profileCountry_MT: 'Malta',
      profileCountry_NO: 'Norway',
      profileCountry_PT: 'Portugal',
      profileCountry_IT: 'Italy',
      profileAcceptsTerms: 'Yes, i have read and accepts the',
      profileAcceptsTerms2: 'terms.',
      profileAcceptPart2: '',
      profileAcceptPart3: '',
      consumerConfirmTermsTitle: '',
      consumerConfirmTerms: 'We accept used clothing that functions perfectly and is in good condition. We will give you credit that can be used in our store. Please note that items will not be returned to customers. Items without garment tags or that are not in good working condition will be recycled and will not be returned.',
      consumerConfirmTerms1: 'Inspect your gear and make sure that what you\'re sending us is good quality.',
      consumerConfirmTerms2: 'Print the shipping label and ship us your gear.',
      consumerConfirmTerms3: '',
      consumerConfirmOk: 'OK',
      shippingTitle: 'Select drop off',
      shippingDescription: 'Select one of our the drop off possibilities. Below you find which ones are available in you neighborhood.',
      carrierName_shipmondo: 'Post Nord parcel shop',
      carrierDescription_shipmondo: 'Please print the shipping label and tape it on securely and visibly.',
      carrierName_pickup: 'Pick up',
      carrierDescription_pickup: 'You will be notified ASAP on how you decide when we can pick up the item(s) from your location',
      carrierName_dao: 'DAO',
      carrierDescription_dao: 'Send your package using the provided code',
      carrierName_gls: 'GLS',
      carrierDescription_gls: 'Please print the shipping label and tape it on securely and visibly.',
      carrierName_b2c: 'DHL',
      carrierDescription_b2c: 'Send your package using DHL',
      carrierName_dhl: 'DHL',
      carrierDescription_dhl: 'Send your package using DHL',
      consumerFreightNoService: 'We are sorry, but we currently have no drop off services in your area. If you think this is a mistake, please contact our customer service',
      tradeInTitle: 'Almost there!',
      tradeInDescription: 'Thank you for your trade in! The next steps are easy peasy - just follow the guide below.',
      tradeInMaximumTitle: 'TradeIn not allowed, maximum value exceeded',
      tradeInMaximumDesc: 'We are very sorry, but the value of your tradein exceeds the maximum allowed value. Try removing an item from the tradein and try again',
      tradeInMaximumCart: 'Unable to add more items',
      tradeInMaximumCart2: 'To continue the trade-in, please remove items so that the trade-in falls below',
      consumerAlmostTherePackIt: 'Pack it',
      consumerAlmostTherePackItDesc: 'Pack your clean items nicely. If possible, pay it back to Mother Earth using a non-virgin packaging. Secure the packaging and put the code or label visibly on it. The shipping is prepaid by us! If still in doubt see how below.',
      consumerAlmostTherePickupPackItDesc: 'Pack your clean items nicely. If possible, pay it back to Mother Earth using a non-virgin packaging. No shipping codes or labels needed - we will take care of that.',
      consumerAlmostTherePackItCode: 'Use personal packing code:',
      consumerAlmostTherePackItLabel: 'Print your packaging label:',
      consumerAlmostTherePackItQR: 'Show this QR code at a drop off point:',
      consumerAlmostTherePackItLabelButton: 'Click here',
      consumerAlmostTherePackItQRButton: 'Show fullscreen',
      consumerAlmostTherePackItHowTo: 'In doubt? click here',
      consumerAlmostThereDropOff: 'Drop off',
      consumerAlmostThereDropOffDesc: 'Drop off the package at a local drop off location. Find the one closest to you below.',
      consumerAlmostThereDropOffDescNoDrops: 'Drop off the package at a local drop off location.',
      consumerAlmostThereDropOffFindNearest: 'Find nearest drop off point',
      consumerAlmostThereCredit: 'Credit',
      consumerAlmostThereCreditDesc: 'Sit back and relax! We will send you an email once your credit is ready for use. You can also see the status of your trade ins under ‘Trade in history’. Thank you for being an environment conscious fashionista!',
      consumerAlmostTHereBackToStart: 'Back to start',
      consumerAlmostThereBackToStartUrl: '',
      consumerAlmostThereCTA1: '',
      consumerAlmostThereCTA1Url: '',
      consumerAlmostThereCTA2: '',
      consumerAlmostThereCTA2Url: '',
      consumerAlmostTherePickup2: 'Pick-up',
      consumerAlmostTherePickupDesc2: 'You will be notified ASAP to agree on a pick-up time',
      consumerAlmostTherePleaseWait: 'Please wait while we make transport arrangements for you ... ',
      consumerAlmostThereDelayedLine1: 'We are currently unable to provide you with shipping details, but we will send you an e-mail when its ready',
      consumerAlmostThereDelayedLine2: 'If you wish, you can keep this window open, it will show the shipping details when they are ready',
      consumerAlmostThereNoticeMail: 'Nota. Le hemos enviado un correo electrónico que incluye la información anterior.',
      consumerAlmostThereStep1Image: '',
      consumerAlmostThereStep2Image: '',
      consumerAlmostThereStep3Image: '',
      consumerDropoffTitle: 'Dropoff points',
      consumerDropoffHide: 'Hide',
      consumerHowToApplyCode: 'How to use code',
      consumerHowToApplyLabel: 'How to apply label',
      consumerHowToApplyCodeSect1: 'Shipping code',
      consumerHowToApplyCodeSect1Desc: 'Before dropping the packaged off at the drop off location, write the 9 digit code visibly and with your best penmanship. Make sure to use a waterproof marker that doesn’t wipe off easily.',
      consumerHowToApplyCodeSect1Image: "",
      consumerHowToApplyCodeSect2: 'Shipping label',
      consumerHowToApplyCodeSect2Desc: 'Before dropping the packaged off at the drop off location, print the shipping label and tape it on securely and visibly. Make sure the tape doesn’t cover any of the print on the label.',
      consumerHowToApplyCodeSect2Image: "",
      consumerHowToApplyCodeQr: 'QR Code',
      consumerHowToApplyCodeQrDesc: 'Before handing the package over to your chosen package shop, you can show the digital shipping label QR at the drop off point. They will scan it and help you print the shipping label.',
      consumerHowToApplyCodeQrImage: "",
      consumerHowToApplyCodeButton: 'Hide',
      publicPageLoginTitle: 'Items bought online',
      publicPageLoginDescription: '',
      publicPageWholeSaleTitle: 'Items bought at a retailer',
      publicPageWholeSaleDescription: '',
      publicPageAlternativeTitle: '',
      publicPageAlternativeDescription: '',
      publicPageAlternativeField1: '',
      publicPageAlternativeField2: '',
      publicPageAlternativeField3: '',
      publicPageFooter: '',
      frontPageImage1: '',
      frontPageImage2: '',
      frontPageStep1Image: '',
      frontPageStep2Image: '',
      frontPageStep3Image: '',
      wholeSaleCreditButton: 'Receive {0} {1} credits',
      payoutTitle: 'Select your payout',
      payoutDescription: 'Select one of the following payout options.',
      payoutVoucher: 'Voucher for shop',
      payoutBank: 'Payout to partner',
      payoutConfirmOkay: 'Confirm',
      payoutConfirmCancel: 'Cancel',
      payoutFieldRequired: 'Field is required',
      payoutCreditCardTitle: 'Angiv konto og registreringsnummer',
      payoutCreditCardRegNr: 'Registration',
      payoutCreditCardAccount: 'Account number',
      payoutMobilePayTitle: 'Please provide mobilepay phonenumber',
      payoutMobilePayPhone: 'Phonenumber',
      historicPageLink: 'Your tradeins',
      historicPageTitle: 'Your historic tradeins',
      historicPageTradeInPrefix: "Created ",
      historicPageTradeInReceived: "Received",
      historicPageTradeInNotReceived: "Not received",
      historicPageTradeInVoucher: "Voucher: ",
      historicPageTradeInValue: "Current value: ",
      headlessCaption: "Please login to access trade-in",
      fetchingItems: "Please wait...",
      commentsPageTitle: "Tell us the story",
      commentsPageDescription: "We would love to hear your story about these items, how they were used and where",
      commentsPageAccept: "Yes, I accept that my first name and country of residence can be displayed in connection with the sale of this item.",
      commentsPagePlaceholder: "Your products story",
      itemInfoStore: "Store",
      itemInfoStoreTitle: "This item was bought in a store",
      itemInfoOnline: "Online",
      itemInfoOnlineTitle: "This item was bought online",
      dropoffQrInfo: "Este punto de entrega admite códigos QR para un envío fácil de paquetes",
   },
   pl: {
      addAnotherItemTitle: 'Item Added Successfully',
      addAnotherItemPrompt: 'Would you like to add another item?',
      addAnotherItem: 'Yes, Add another',
      addAnotherItemNo: 'No, Thanks',
      currency_dkk: 'DKK',
      currency_eur: "EUR",
      currency_gbp: "GBP",
      currency_nok: "NOK",
      currency_pln: "PLN",
      currency_sek: "SEK",
      currency_usd: "USD",
      currency_point: "POINT",
      loginPageTitle: 'Bring magic to your inbox',
      loginPageDescription: 'Submit your email and we will send you a link with access to our trade in universe of your previously purchased items.',
      loginPageDescription2: 'Let the trade in begin!',
      loginPageDescription3: '',
      loginPageBack: 'Back',
      publicPageTitle: 'Discover the value of your wardrobe',
      publicPageDescription: 'Here you can secure a new home for your used items. Send us your used items and get credit to spend in our webshop.',
      publicPageDescription2: 'We are buying items shopped here or other stores.',
      publicPagePageStartButton: 'Start tradeback',
      publicPageBackgroundImage: '',
      publicPageVideoUrl: '',
      mainPageEnterEmail: 'E-mail',
      mainPageMailSent: 'Thank you! We will send you an email with instructions.',
      mainPageMailSent2: '',
      mainPageSend: 'Submit',
      easyBoxTitle: 'As easy as 1,2,3!',
      easyBoxSection1Icon: '',
      easyBoxSection1Title: 'Trade it',
      easyBoxSection1Description: 'Select the items you want to trade in from a list of your previous purchases. We determine the credit - you spend it!',
      easyBoxSection2Icon: '',
      easyBoxSection2Title: 'Pack it',
      easyBoxSection2Description: 'Pack your clean items nicely and send it to us with a prepaid shipping label or code. That’s right! No shipping fees.',
      easyBoxSection3Icon: '',
      easyBoxSection3Title: 'Drop it off',
      easyBoxSection3Description: 'Drop off the package at your local drop off location and receive instant credit you can use on new or used items in our webshop!',
      easyBoxSection4Icon: '',
      easyBoxSection4Title: '',
      easyBoxSection4Description: '',
      easyBoxSignature: '',
      mainPageStepperReturns: 'Your returns',
      mainPageStepperProfile: 'Your informations',
      mainPageStepperPayout: 'Payout',
      mainPageStepperDelivery: 'Choose pickup',
      mainPageStepperComments: 'Comments',
      returnsDescriptionNone: 'You havent picked your returns yet. Add your first item to get started.',
      returnsAddItem: 'Add items',
      returnsAddItemMore: '',
      returnsAddItemButton: 'Add item',
      returnsTitleDirect: 'Items bought at {0}',
      returnsTitleSubText: '',
      returnsTitleRetail: 'Items bought at a retailer',
      returnsTitleDisallowed: 'Items unavailable for trade-in',
      countryWarningTitle: 'Trade-Ins might not be available in your area',
      countryWarningDescription: 'Thanks for stopping by, but it appears that you come from a country which is not yet fully supported',
      returnsValue: 'Value: ',
      returnsConfirmTrade: 'Trade in',
      wholeSaleAddTitle: 'Add item',
      wholeSaleAddDescription: 'Pick the category for your item, and upload a picture.',
      wholeSaleAddItem: 'Add item',
      wholeSaleAddItem2: 'Add item',
      wholeSaleSearchTitle: 'Search for style',
      wholeSaleSearchSubTitle: 'Locate the style by entering the style number found on the small carelabel inside your item and select from the list.',
      wholeSaleSearchGoCategory: 'Add item by category',
      wholeSaleSearchPlaceholder: 'Search for item',
      wholeSaleSearchNotFound: 'No matching styles found',
      wholeSaleSearchHowToTitle: 'How to find the style number',
      wholeSaleSearchHowToDescription: 'Look at the carelabel as shown on the picture',
      wholeSaleSearchHowToNotFoundTitle: 'Unable to locate the style number?',
      wholeSaleExcluded: 'Unable to trade-in',
      wholeSaleValuePrefix: '',
      wholeSaleAdditionalHeader: '',
      wholeSaleAdditionalDescription: '',
      wholeSaleSearchImageUrl: '',
      wholeSaleSearchItemSuffix: '',
      imageUploadText: 'Upload photo',
      categoryValue: 'Value: ',
      returnsCartHeaderReplacement: '',
      returnsCartHeader: 'For use at ',
      returnsCartNext: 'Continue',
      returnsConfirmDelete: 'Delete item?',
      returnsConfirmDeleteDescription: 'This action will delete the item from your list of returns.',
      returnsConfirmYes: '',
      returnsConfirmNo: '',
      returnsNothingTitle: 'You have no trade-in history',
      returnsNothingDesc: 'But keep looking, we will update this page when you trade with us.',
      profileTitle: 'Your profile',
      profileDescription: 'We need some information about you, so you can get your credit.',
      profileName: 'Full Name',
      profileRequired: 'This field is required',
      profileZipCode: 'Zipcode',
      profileZipCodeValidation: 'Zipcode is invalid',
      profileCity: 'City',
      profileAddress: 'Adres',
      profileMail: 'Email',
      profileMailInvalid: 'Invalid email',
      profilePhone: 'Phone',
      profilePhonePrefix: 'Country Code',
      profilePhoneValidation: 'Phonenumber is invalid',
      profileDataMissingTitle: 'Please fill in all the missing fields',
      profileCountry: 'Country',
      profileLocale: 'Language',
      profileCountry_DK: 'Denmark',
      profileCountry_DE: 'Germany',
      profileCountry_AT: 'Austria',
      profileCountry_NL: 'Netherland',
      profileCountry_SE: 'Sweden',
      profileCountry_BE: 'Belgium',
      profileCountry_IE: 'Ireland',
      profileCountry_FR: 'France',
      profileCountry_ES: 'Spain',
      profileCountry_RO: 'Romania',
      profileCountry_SI: 'Slovenia',
      profileCountry_SK: 'Slovakia',
      profileCountry_CZ: 'Czech Republic',
      profileCountry_PL: 'Poland',
      profileCountry_BG: 'Bulgaria',
      profileCountry_CY: 'Cyprus',
      profileCountry_EE: 'Estonia',
      profileCountry_FI: 'Finland',
      profileCountry_GB: 'United Kingdom',
      profileCountry_GR: 'Greece',
      profileCountry_HR: 'Croatia',
      profileCountry_LT: 'Lithuania',
      profileCountry_LU: 'Luxembourg',
      profileCountry_LV: 'Latvia',
      profileCountry_HU: 'Hungary',
      profileCountry_MT: 'Malta',
      profileCountry_NO: 'Norway',
      profileCountry_PT: 'Portugal',
      profileCountry_IT: 'Italy',
      profileAcceptsTerms: 'Yes, i have read and accepts the',
      profileAcceptsTerms2: 'terms.',
      profileAcceptPart2: '',
      profileAcceptPart3: '',
      consumerConfirmTermsTitle: '',
      consumerConfirmTerms: 'We accept used clothing that functions perfectly and is in good condition. We will give you credit that can be used in our store. Please note that items will not be returned to customers. Items without garment tags or that are not in good working condition will be recycled and will not be returned.',
      consumerConfirmTerms1: 'Inspect your gear and make sure that what you\'re sending us is good quality.',
      consumerConfirmTerms2: 'Print the shipping label and ship us your gear.',
      consumerConfirmTerms3: '',
      consumerConfirmOk: 'OK',
      shippingTitle: 'Select drop off',
      shippingDescription: 'Select one of our the drop off possibilities. Below you find which ones are available in you neighborhood.',
      carrierName_shipmondo: 'Post Nord parcel shop',
      carrierDescription_shipmondo: 'Please print the shipping label and tape it on securely and visibly.',
      carrierName_pickup: 'Pick up',
      carrierDescription_pickup: 'You will be notified ASAP on how you decide when we can pick up the item(s) from your location',
      carrierName_dao: 'DAO',
      carrierDescription_dao: 'Send your package using the provided code',
      carrierName_gls: 'GLS',
      carrierDescription_gls: 'Please print the shipping label and tape it on securely and visibly.',
      carrierName_b2c: 'DHL',
      carrierDescription_b2c: 'Send your package using DHL',
      carrierName_dhl: 'DHL',
      carrierDescription_dhl: 'Send your package using DHL',
      consumerFreightNoService: 'We are sorry, but we currently have no drop off services in your area. If you think this is a mistake, please contact our customer service',
      tradeInTitle: 'Almost there!',
      tradeInDescription: 'Thank you for your trade in! The next steps are easy peasy - just follow the guide below.',
      tradeInMaximumTitle: 'TradeIn not allowed, maximum value exceeded',
      tradeInMaximumDesc: 'We are very sorry, but the value of your tradein exceeds the maximum allowed value. Try removing an item from the tradein and try again',
      tradeInMaximumCart: 'Unable to add more items',
      tradeInMaximumCart2: 'To continue the trade-in, please remove items so that the trade-in falls below',
      consumerAlmostTherePackIt: 'Pack it',
      consumerAlmostTherePackItDesc: 'Pack your clean items nicely. If possible, pay it back to Mother Earth using a non-virgin packaging. Secure the packaging and put the code or label visibly on it. The shipping is prepaid by us! If still in doubt see how below.',
      consumerAlmostTherePickupPackItDesc: 'Pack your clean items nicely. If possible, pay it back to Mother Earth using a non-virgin packaging. No shipping codes or labels needed - we will take care of that.',
      consumerAlmostTherePackItCode: 'Use personal packing code:',
      consumerAlmostTherePackItLabel: 'Print your packaging label:',
      consumerAlmostTherePackItQR: 'Show this QR code at a drop off point:',
      consumerAlmostTherePackItLabelButton: 'Click here',
      consumerAlmostTherePackItQRButton: 'Show QR fullscreen',
      consumerAlmostTherePackItHowTo: 'In doubt? click here',
      consumerAlmostThereDropOff: 'Drop off',
      consumerAlmostThereDropOffDesc: 'Drop off the package at a local drop off location. Find the one closest to you below.',
      consumerAlmostThereDropOffDescNoDrops: 'Drop off the package at a local drop off location.',
      consumerAlmostThereDropOffFindNearest: 'Find nearest drop off point',
      consumerAlmostThereCredit: 'Credit',
      consumerAlmostThereCreditDesc: 'Sit back and relax! We will send you an email once your credit is ready for use. You can also see the status of your trade ins under ‘Trade in history’. Thank you for being an environment conscious fashionista!',
      consumerAlmostTHereBackToStart: 'Back to start',
      consumerAlmostThereBackToStartUrl: '',
      consumerAlmostThereCTA1: '',
      consumerAlmostThereCTA1Url: '',
      consumerAlmostThereCTA2: '',
      consumerAlmostThereCTA2Url: '',
      consumerAlmostTherePickup2: 'Pick-up',
      consumerAlmostTherePickupDesc2: 'You will be notified ASAP to agree on a pick-up time',
      consumerAlmostTherePleaseWait: 'Please wait while we make transport arrangements for you ... ',
      consumerAlmostThereDelayedLine1: 'We are currently unable to provide you with shipping details, but we will send you an e-mail when its ready',
      consumerAlmostThereDelayedLine2: 'If you wish, you can keep this window open, it will show the shipping details when they are ready',
      consumerAlmostThereNoticeMail: 'Notatka. Wysłaliśmy do Ciebie e-mail zawierający powyższe informacje.',
      consumerAlmostThereStep1Image: '',
      consumerAlmostThereStep2Image: '',
      consumerAlmostThereStep3Image: '',
      consumerDropoffTitle: 'Dropoff points',
      consumerDropoffHide: 'Hide',
      consumerHowToApplyCode: 'How to use code',
      consumerHowToApplyLabel: 'How to apply label',
      consumerHowToApplyCodeSect1: 'Shipping code',
      consumerHowToApplyCodeSect1Desc: 'Before dropping the packaged off at the drop off location, write the 9 digit code visibly and with your best penmanship. Make sure to use a waterproof marker that doesn’t wipe off easily.',
      consumerHowToApplyCodeSect1Image: "",
      consumerHowToApplyCodeSect2: 'Shipping label',
      consumerHowToApplyCodeSect2Desc: 'Before dropping the packaged off at the drop off location, print the shipping label and tape it on securely and visibly. Make sure the tape doesn’t cover any of the print on the label.',
      consumerHowToApplyCodeSect2Image: "",
      consumerHowToApplyCodeQr: 'QR Code',
      consumerHowToApplyCodeQrDesc: 'Before handing the package over to your chosen package shop, you can show the digital shipping label QR at the drop off point. They will scan it and help you print the shipping label.',
      consumerHowToApplyCodeQrImage: "",
      consumerHowToApplyCodeButton: 'Hide',
      publicPageLoginTitle: 'Items bought online',
      publicPageLoginDescription: '',
      publicPageWholeSaleTitle: 'Items bought at a retailer',
      publicPageWholeSaleDescription: '',
      publicPageAlternativeTitle: '',
      publicPageAlternativeDescription: '',
      publicPageAlternativeField1: '',
      publicPageAlternativeField2: '',
      publicPageAlternativeField3: '',
      publicPageFooter: '',
      frontPageImage1: '',
      frontPageImage2: '',
      frontPageStep1Image: '',
      frontPageStep2Image: '',
      frontPageStep3Image: '',
      wholeSaleCreditButton: 'Receive {0} {1} credits',
      payoutTitle: 'Select your payout',
      payoutDescription: 'Select one of the following payout options.',
      payoutVoucher: 'Voucher for shop',
      payoutBank: 'Partner to partner',
      payoutConfirmOkay: 'Confirm',
      payoutConfirmCancel: 'Cancel',
      payoutFieldRequired: 'Field is required',
      payoutCreditCardTitle: 'Angiv konto og registreringsnummer',
      payoutCreditCardRegNr: 'Registration',
      payoutCreditCardAccount: 'Account number',
      payoutMobilePayTitle: 'Please provide mobilepay phonenumber',
      payoutMobilePayPhone: 'Phonenumber',
      historicPageLink: 'Your tradeins',
      historicPageTitle: 'Your historic tradeins',
      historicPageTradeInPrefix: "Created ",
      historicPageTradeInReceived: "Received",
      historicPageTradeInNotReceived: "Not received",
      historicPageTradeInVoucher: "Voucher: ",
      historicPageTradeInValue: "Current value: ",
      headlessCaption: "Please login to access trade-in",
      fetchingItems: "Please wait...",
      commentsPageTitle: "Tell us the story",
      commentsPageDescription: "We would love to hear your story about these items, how they were used and where",
      commentsPageAccept: "Yes, I accept that my first name and country of residence can be displayed in connection with the sale of this item.",
      commentsPagePlaceholder: "Your products story",
      itemInfoStore: "Store",
      itemInfoStoreTitle: "This item was bought in a store",
      itemInfoOnline: "Online",
      itemInfoOnlineTitle: "This item was bought online",
      dropoffQrInfo: "Ten punkt odbioru obsługuje kody QR dla łatwego wysyłania paczek",
   }
};
